import React, { useCallback, useEffect, useRef, useState } from "react";
import {
  Box,
  Typography,
  TextField,
  IconButton,
  Avatar,
  Button,
  Paper,
  InputAdornment,
  Menu,
  MenuItem,
  Card,
  CardContent,
  FormControl,
  InputLabel,
  Select,
  // FormControlLabel,
  // Checkbox,
  Dialog,
  CircularProgress,
  Fab,
  Autocomplete,
  Chip,
  Snackbar,
  Alert,
  Tooltip,
   Badge,
  Divider,
} from "@mui/material";
import ChatOutlinedIcon from "@mui/icons-material/ChatOutlined";
import {
  Search as SearchIcon,
  FilterList as FilterListIcon,
  // FilterList as FilterIcon,
  Add as AddIcon,
  Star as StarIcon,
  AssignmentInd as AssignmentIndIcon,
  // Send as SendIcon,
  // AttachFile as AttachIcon,
  // EmojiEmotions as EmojiIcon,
  Image as ImageIcon,
  // SmartToy as BotIcon,
  // Edit as EditIcon,
  // Delete as DeleteIcon,
  WhatsApp as WhatsAppIcon,
  // Chat as ChatIcon,
  // Flag as FlagIcon,
  LocalOffer as LabelIcon,
  // AccessTime as TimerIcon,
  ArrowDownward as ArrowDownwardIcon,
  ExpandLess,
  ExpandMore,
  AudioFile,
  AudiotrackOutlined,
  StopCircle,
  CheckCircleOutline as CheckCircleOutlineIcon,
  ArrowDropDown as ArrowDropDownIcon,
  ErrorOutline as ErrorOutlineIcon,
  InfoOutlined as InfoOutlinedIcon,
  MoreVert as MoreVertIcon,
  Check as CheckIcon,
  Clear as ClearIcon,
  Markunread as MarkunreadIcon,
  Person as PersonIcon,
  PersonOff as PersonOffIcon,
  HourglassEmpty as HourglassEmptyIcon,
  AllInbox as AllInboxIcon,
} from "@mui/icons-material";
import ConversationService from "../services/ConversationService";
import { getProperTime } from "../utils/extentions";
import MyAccountService from "../services/MyAccountService";
// import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
// import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import MessageTemplateService from "../services/MessageTemplateService";
import { ContactsSelectDialog } from "../components/ContactsDialog";
import TagService from "../services/TagService";
import ContactApiService from "../services/ContactApiService";
import InsertEmoticonIcon from "@mui/icons-material/InsertEmoticon";
// import data from '@emoji-mart/data';
// import Picker from '@emoji-mart/react';
import MediaUploadDialog from "../components/MediaUploadDialog";
import ImageViewerOverlay from "../components/ImageViewerOverlay";
import { ChatColumn, ContactColumn, InboxColumn } from "../components/teamchat/LayoutColumns";
import CallButton from "../components/CallButton";
import useCallPermission from "../hooks/useCallPermission";
import useIncomingCall from '../hooks/useIncomingCall';
import IncomingCallNotification from "../components/IncomingCallNotification";
import servicesService from '../services/ServicesService';
import appConfig from '../shared/js/app-config';
import CallHistory from "../components/CallHistory";
import MissedCallNotification from "../components/MissedCallNotification";
import CallMessageBubble, { getCallPreviewText } from "../components/CallMessageBubble";

const WA_THEME = {
  appBg: "#e9edef",
  panelBg: "#f0f2f5",
  wallpaper: {
    backgroundColor: "#efeae2",
    backgroundImage:
      "radial-gradient(rgba(255,255,255,0.32) 1px, transparent 1px), radial-gradient(rgba(0,0,0,0.03) 1px, transparent 1px)",
    backgroundPosition: "0 0, 18px 18px",
    backgroundSize: "36px 36px",
  },
  primary: "#1976d2",
  primaryDark: "#029377",
  sentBubble: "#d9fdd3",
  receiveBubble: "#ffffff",
};
const CHAT_IMAGE_SIZE = {
  cardWidth: { xs: 210, sm: 230, md: 250 },
  maxHeight: { xs: 170, sm: 190, md: 210 },
};

const CHAT_IMAGE_SX = {
  width: "100%",
  maxWidth: "100%",
  maxHeight: CHAT_IMAGE_SIZE.maxHeight,
  borderRadius: 2,
  mb: 1,
  display: "block",
  mx: 0,
  objectFit: "cover",
  cursor: "pointer",
  transition: "opacity 0.15s ease",
  "&:hover": { opacity: 0.92 },
};

/** Native audio controls need a minimum width; "auto" bubbles collapse without this. */
const CHAT_AUDIO_BUBBLE = {
  width: { xs: "min(92vw, 300px)", sm: 300, md: 320 },
  minWidth: { xs: 260, sm: 280, md: 300 },
  flexShrink: 0,
};

function isAudioChatMessage(msg) {
  if (!msg?.mediaUrl) return false;
  if (msg.message_type === "audio") return true;
  const mediaType = String(msg.media_type || "").toLowerCase();
  return mediaType.includes("audio");
}

const CONTACT_PANEL_CARD_SX = {
  p: 1.5,
  mb: 1,
  borderRadius: 2,
  bgcolor: "#fff",
  boxShadow: "0 1px 3px rgba(15,23,42,0.08)",
  width: "100%",
  boxSizing: "border-box",
  minWidth: 0,
};

const HEADER_MEDIA_SIZE_LIMITS = {
  image: 5 * 1024 * 1024,
  video: 16 * 1024 * 1024,
  document: 100 * 1024 * 1024,
};

/** Same pseudo-id as whatsapp-server routing `AI_BOT_ASSIGNEE_ID` (team assign → persistent AI session). */
const TEAM_INBOX_AI_ASSIGNEE_OPTION = Object.freeze({
  id: "ai_bot",
  first_name: "AI",
  last_name: "Assistant",
  email: "",
});

const FILTER_TO_DB_MAP = {
  'queued': 'unassigned',      
  'pending': 'unassigned',     
  'assigned': 'assigned',      
  'unassigned': 'unassigned',  
  'closed': 'closed',        
  'assigned_to_me': 'assigned',
};

const TeamChatView = () => {
  const [message, setMessage] = useState("");
  const [anchorEl, setAnchorEl] = useState(null);
  const [timer, setTimer] = useState(null);
  const [conversations, setConversations] = useState([]);
  const [page, setPage] = useState(1);
  const [hasNext, setHasNext] = useState(true);
  const [loading, setLoading] = useState(false);
  const [selectedConversationId, setSelectedConversationId] = useState(null);
  const [messages, setMessages] = useState([]);
  const [messagesPage, setMessagesPage] = useState(1);
  const [messagesHasPrev, setMessagesHasPrev] = useState(true);
  const [messagesLoading, setMessagesLoading] = useState(false);
  const [contactname, setContactName] = useState("");
  const [contactemail, setContactEmail] = useState("");
  const [contactId, setContactId] = useState(null);
  const [timeLeft, setTimeLeft] = useState(null);
  const [members, setMembers] = useState(null);
  const [approvedTemplates, setApprovedTemplates] = useState([]);
  const [showChatListMobile, setShowChatListMobile] = useState(true);
  const [showContactMobile, setShowContactMobile] = useState(false);
  const [sending, setSending] = useState(false);
  const [formData, setFormData] = useState({
    selectedTemplate: "",
    tags: [],
  });
  const [errors, setErrors] = useState({});
  const [templateVariables, setTemplateVariables] = useState({ header: {}, body: {}, footer: {} });
  const [templateMediaHeaderUrl, setTemplateMediaHeaderUrl] = useState("");
  const [templateHeaderMediaUploading, setTemplateHeaderMediaUploading] = useState(false);
  const teamTemplateHeaderFileRef = useRef(null);
  const [templateDialogOpen, setTemplateDialogOpen] = useState(false);
  const [searchKey, setSearchKey] = useState(null);
  const [assignmentStatusFilter, setAssignmentStatusFilter] = useState("");
  const [selectedChat, setSelectedChat] = useState(null);
  const [assignDialogOpen, setAssignDialogOpen] = useState(false);
  const [unassignDialogOpen, setUnassignDialogOpen] = useState(false);
  const [closeDialogOpen, setCloseDialogOpen] = useState(false);
  const [staffForAssign, setStaffForAssign] = useState([]);
  const [assignTargetId, setAssignTargetId] = useState(null);
  const [assignBusy, setAssignBusy] = useState(false);
  const [routingPolicy, setRoutingPolicy] = useState({ allow_agent_claim: true });
  const [currentAccountId, setCurrentAccountId] = useState(null);
  const [currentAccountType, setCurrentAccountType] = useState(null);
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "error",
  });
  const [sectionOpen, setSectionOpen] = useState({
    contactInfo: true,
    contactAttrs: true,
    tags: true,
    notes: true,
  });
  const [open, setOpen] = useState(false);
  const[selectedNewContact, setSelectedNewContact] = useState(null);
  const [contactError, setContactError] = useState(null);
  const messageContainerRef = useRef(null);
  const lastActionRef = useRef(null);
  const [showScrollToBottom, setShowScrollToBottom] = useState(false);
  let container = messageContainerRef.current;
  const [limit, setLimit] = useState(10);
  const timerIntervalRef = useRef();
  const [imageDialogOpen, setImageDialogOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const [imageUploading, setImageUploading] = useState(false);
  const [imageViewer, setImageViewer] = useState({ open: false, url: "", caption: "" });
  const [caption, setCaption] = useState("");
  const [audioDialogOpen, setAudioDialogOpen] = useState(false);
  const [selectedAudio, setSelectedAudio] = useState(null);
  const [audioUploading, setAudioUploading] = useState(false);
  const [isRecording, setIsRecording] = useState(false);
  const [recordedAudio, setRecordedAudio] = useState(null);
  const [mediaStream, setMediaStream] = useState(null);
  const [availableTags, setAvailableTags] = useState([]);
  const [newTag, setNewTag] = useState("");
  const [emojiDialogOpen, setEmojiDialogOpen] = useState(false);
  const [reactingWamid, setReactingWamid] = useState(null);
  const mediaRecorderRef = useRef(null);
  const audioChunksRef = useRef([]);
  const recorderRef = useRef(null);
  const [phoneNumberId, setPhoneNumberId] = useState(null);
  const [callHistoryRefreshKey, setCallHistoryRefreshKey] = useState(0);
  const [filterAnchorEl, setFilterAnchorEl] = useState(null);
  const filterMenuOpen = Boolean(filterAnchorEl);
  const [unreadCount, setUnreadCount] = useState(0);
  const emojiTitle = reactingWamid
  ? "React to Message"
  : "Select Emoji";

  const inboxQuickFilters = [
  { id: "", label: "All", icon: AllInboxIcon, color: "#64748b" },
  { id: "assigned", label: "Open", icon: AssignmentIndIcon, color: "#22c55e" },
  { id: "assigned_to_me", label: "Assigned to me", icon: PersonIcon, color: "#3b82f6" },
  { id: "queued", label: "Pending", icon: HourglassEmptyIcon, color: "#f97316" },
  { id: "unread", label: "Unread", icon: MarkunreadIcon, color: "#f59e0b" },
  { id: "unassigned", label: "Unassigned", icon: PersonOffIcon, color: "#6b7280" },
  { id: "closed", label: "Closed", icon: CheckCircleOutlineIcon, color: "#9ca3af" },
];
  const calculateUnreadCount = (conversationsList) => {
  return conversationsList.reduce(
    (acc, c) => acc + (Number(c?.new_message_count || 0) > 0 ? 1 : 0),
    0,
  );
};

  // const visibleConversations = assignmentStatusFilter === "unread"
  //   ? conversations.filter((c) => Number(c?.new_message_count || 0) > 0)
  //   : conversations;

const visibleConversations = (() => {
  
  if (assignmentStatusFilter === "unread") {
    return conversations.filter((c) => Number(c?.new_message_count || 0) > 0);
  }
  const dbStatus = FILTER_TO_DB_MAP[assignmentStatusFilter];
  if (dbStatus) {
    return conversations.filter((c) => c.assignment_status === dbStatus);
  }
  
  
  return conversations;
})();
  const resolveStaffName = (accountId) => {
    if (!accountId) return null;
    if (accountId === TEAM_INBOX_AI_ASSIGNEE_OPTION.id) return "AI Assistant";
    const row = (staffForAssign || []).find((s) => s.id === accountId);
    if (!row) return accountId;
    return `${row.first_name || ""} ${row.last_name || ""}`.trim() || row.email || accountId;
  };
  const isCurrentAssignee = Boolean(
    selectedChat?.current_assignee_account_id
      && currentAccountId
      && selectedChat.current_assignee_account_id === currentAccountId,
  );
  const isCurrentOwner = Boolean(
    selectedChat?.owner_account_id
      && currentAccountId
      && selectedChat.owner_account_id === currentAccountId,
  );
  const hasAssignee = Boolean(selectedChat?.current_assignee_account_id);
  const isAssignedToAiBot = selectedChat?.current_assignee_account_id === TEAM_INBOX_AI_ASSIGNEE_OPTION.id;
  const currentUserIsAdmin = currentAccountType === "admin" || currentAccountType === "super_admin";
  const canManageAssignments = currentUserIsAdmin || isCurrentOwner;
  const canReplyToSelectedChat = !hasAssignee || isCurrentAssignee || isCurrentOwner
    || (canManageAssignments && isAssignedToAiBot);
  const showSnackbar = (message, severity = "error") => {
    setSnackbar({ open: true, message, severity });
  };

  const handleMenuClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleFilterMenuClick = (event) => {
  setFilterAnchorEl(event.currentTarget);
  };
  const handleFilterMenuClose = () => {
  setFilterAnchorEl(null);
  };

  useEffect(() => {
  const count = calculateUnreadCount(conversations);
  setUnreadCount(count);
}, [conversations]);

  useEffect(() => {
    if (!timer) {
      setTimeLeft('Expired');
      return;
    }
    function updateTimer() {
      const now = new Date();
      const targetTime = new Date(timer); 
      const diffMs = (targetTime.getTime() + 24 * 60 * 60 * 1000) - now.getTime();
      if (diffMs <= 0) {
        setTimeLeft('Expired');
        setTimer(null);
        if (timerIntervalRef.current) {
          clearInterval(timerIntervalRef.current);
          timerIntervalRef.current = null;
        }
        return;
      }

      const diffHours = Math.floor(diffMs / (1000 * 60 * 60));
      const diffMinutes = Math.floor((diffMs % (1000 * 60 * 60)) / (1000 * 60));
      const formatted = `${String(diffHours).padStart(2, '0')}:${String(diffMinutes).padStart(2, '0')}`;
      setTimeLeft(formatted);
    }

    updateTimer();
    if (timerIntervalRef.current) clearInterval(timerIntervalRef.current);
    timerIntervalRef.current = setInterval(updateTimer, 1000);

    return () => {
      if (timerIntervalRef.current) {
        clearInterval(timerIntervalRef.current);
        timerIntervalRef.current = null;
      }
    };
  }, [timer]);
  const linkRegex = /(https?:\/\/[^\s]+)/g;

function LinkifiedText({ text }) {
  const parts = text.split(linkRegex);

  return (
    <>
      {parts.map((part, index) =>
        linkRegex.test(part) ? (
          <a
            key={index}
            href={part}
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: "#1976d2", textDecoration: "underline" }}
          >
            {part}
          </a>
        ) : (
          part
        )
      )}
    </>
  );
}

const isDocumentMessageType = (type) => type === "file" || type === "document";

function renderChatMediaContent(msg, onImageClick) {
  if (msg.message_type === "image" && msg.mediaUrl) {
    return (
      <>
        <Box
          component="img"
          src={msg.mediaUrl}
          alt="image"
          sx={CHAT_IMAGE_SX}
          onClick={() => onImageClick?.(msg.mediaUrl, msg.content || "")}
        />
        {msg.content ? (
          <Typography
            variant="body2"
            sx={{ whiteSpace: "pre-wrap", wordBreak: "break-word" }}
          >
            <LinkifiedText text={msg.content} />
          </Typography>
        ) : null}
      </>
    );
  }

  if (isAudioChatMessage(msg)) {
    return (
      <>
        <Box
          sx={{
            width: "100%",
            minWidth: 260,
            flexShrink: 0,
            mb: msg.content ? 1 : 0,
          }}
        >
          <audio
            controls
            preload="metadata"
            src={msg.mediaUrl}
            style={{
              width: "100%",
              minWidth: 260,
              height: 42,
              display: "block",
            }}
          />
        </Box>
        {msg.content ? (
          <Typography
            variant="body2"
            sx={{ whiteSpace: "pre-wrap", wordBreak: "break-word" }}
          >
            {msg.content}
          </Typography>
        ) : null}
      </>
    );
  }

  if (msg.message_type === "video" && msg.mediaUrl) {
    return (
      <>
        <Box
          component="video"
          src={msg.mediaUrl}
          controls
          sx={{
            width: "100%",
            maxWidth: "100%",
            maxHeight: CHAT_IMAGE_SIZE.maxHeight,
            borderRadius: 2,
            mb: 1,
            display: "block",
          }}
        />
        {msg.content ? (
          <Typography
            variant="body2"
            sx={{ whiteSpace: "pre-wrap", wordBreak: "break-word" }}
          >
            <LinkifiedText text={msg.content} />
          </Typography>
        ) : null}
      </>
    );
  }

  if (isDocumentMessageType(msg.message_type) && msg.mediaUrl) {
    return (
      <>
        <Button
          component="a"
          href={msg.mediaUrl}
          target="_blank"
          rel="noopener noreferrer"
          variant="outlined"
          size="small"
          startIcon={<AudioFile />}
          sx={{
            textTransform: "none",
            mb: msg.content ? 1 : 0,
            maxWidth: "100%",
            justifyContent: "flex-start",
          }}
        >
          {msg.content || "Download document"}
        </Button>
      </>
    );
  }

  if (msg.message_type === "sticker") {
    return msg.mediaUrl ? (
      <Box
        component="img"
        src={msg.mediaUrl}
        alt="sticker"
        sx={{
          maxWidth: "160px",
          maxHeight: "160px",
          width: "auto",
          height: "auto",
          borderRadius: "12px",
          cursor: "pointer",
          transition: "transform 0.2s ease",
          "&:hover": { transform: "scale(1.05)" },
        }}
        onClick={() => onImageClick?.(msg.mediaUrl)}
      />
    ) : (
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          width: "100px",
          height: "100px",
          bgcolor: "#f5f5f5",
          borderRadius: "12px",
        }}
      >
        <CircularProgress size={30} />
      </Box>
    );
  }

  return null;
}

function renderOutboundStatus(status, errorMessage) {
  if (status === "failed") {
    return (
      <Tooltip title={errorMessage || "Failed to deliver message"} placement="top" arrow>
        <ErrorOutlineIcon sx={{ fontSize: 14, color: "#d32f2f", cursor: "help" }} />
      </Tooltip>
    );
  }

  const tickColor = status === "read" ? "#1d9bf0" : "#6b7280";
  return (
    <Box sx={{ display: "flex" }}>
      <Box
        sx={{
          width: 4,
          height: 8,
          borderBottom: `2px solid ${tickColor}`,
          borderRight: `2px solid ${tickColor}`,
          transform: "rotate(45deg)",
        }}
      />
      <Box
        sx={{
          width: 4,
          height: 8,
          borderBottom: `2px solid ${tickColor}`,
          borderRight: `2px solid ${tickColor}`,
          transform: "rotate(45deg)",
          ml: "-2px",
        }}
      />
    </Box>
  );
}

  async function handleSendMessage() {
    if (!canReplyToSelectedChat) {
      showSnackbar("Only the assignee or owner can reply to this assigned chat.");
      return;
    }
    if (message.trim()) {
      try {
        const messagePayload = {
          conversation_id: selectedConversationId,
          message: message.trim(),
          contact_id: contactId,
          message_type: 'text',
          media_id: null,
          media_type: null,
        }
        await ConversationService.sendMessage(messagePayload);
        setSending(true);
        handleClickConversation();
      // fetch(false);
      } catch (error) {
        console.error("Failed Sedning message:", error);
      }
      setMessage("");
      // fetch();
    }
  };

  async function handleSendImage(file, caption) {
    if (!canReplyToSelectedChat) {
      showSnackbar("Only the assignee or owner can reply to this assigned chat.");
      return;
    }
    if (!file) return;
    setImageUploading(true);
    try {
      const messagePayload = {
        conversation_id: selectedConversationId,
        message: caption?.trim(),
        contact_id: contactId,
        message_type: 'media',
        // image: selectedImage,
        image: file,
      }
      await ConversationService.sendMessage(messagePayload);
      setImageDialogOpen(false);
      setSelectedImage(null);
      setCaption("");
      handleClickConversation();
    } catch (error) {
      console.error('Failed to send image:', error);
    }
    setImageUploading(false);
  }

  async function handleSendAudio(file) {
    if (!canReplyToSelectedChat) {
      showSnackbar("Only the assignee or owner can reply to this assigned chat.");
      return;
    }
    if (!file) return;
    setAudioUploading(true);
    try {
      const messagePayload = {
        conversation_id: selectedConversationId,
        message: null,
        contact_id: contactId,
        message_type: 'media',
        audio: file,
      }
      await ConversationService.sendMessage(messagePayload);
      setAudioDialogOpen(false);
      setSelectedAudio(null);
      setCaption("");
      handleClickConversation();
    } catch (error) {
      console.error('Failed to send image:', error);
    }
    setAudioUploading(false);
  }

  async function stopMicrophone() {
     if (mediaStream) {
      mediaStream.getTracks().forEach(track => track.stop());
      setMediaStream(null);
      console.log("Microphone stopped");
    }
  }

  async function handleSendRecordedAudio() {
    if (!canReplyToSelectedChat) {
      showSnackbar("Only the assignee or owner can reply to this assigned chat.");
      return;
    }
    stopMicrophone()
    if (!recordedAudio) return;
    setAudioUploading(true);
    try {
       const messagePayload = {
          conversation_id: selectedConversationId,
          message: null,
          contact_id: contactId,
          message_type: 'media',
          is_voice: true,
          record: recordedAudio,
        }
      await ConversationService.sendMessage(messagePayload);
      setRecordedAudio(null);
      setAudioUploading(false);
      handleClickConversation();
    } catch (error) {
      console.error('Failed to send image:', error);
    }
  }

  function handleSelectContact(contact) {
    if (contact.length > 1) {
     return setContactError('Select only one contact');
    } else if (contact.length === 0) {
     return setContactError('Select atleast one contact');
    } else if (contact.length === 1) {
      setSelectedNewContact(contact);
    }
    setContactError(null);
    setOpen(false);
  }
  const normalizePhone = (s) => {
    if (!s) return "";
    return String(s).replace(/\D/g, "");
  };
  useEffect(() => {
  if (conversations.length > 0 && !selectedConversationId) {
    const firstChat = conversations[0];
    const firstContact = firstChat.members?.[0];

    setSelectedConversationId(firstChat.id);
    handleClickConversation(firstChat, firstContact);
  }
}, [conversations]);

  useEffect(() => {
    if (!selectedNewContact) return;
    const sel = Array.isArray(selectedNewContact) ? selectedNewContact[0] : selectedNewContact;
    if (!sel) return;
    const selPhone = normalizePhone(sel.phoneNumber || sel.phone || sel.phone_number || sel.attrs?.phoneNumber);
    const existingConv = conversations.find((c) =>
      c.members?.some((m) => {
        const mPhone = normalizePhone(m.phone_number || m.phone || m.attrs?.phoneNumber);
        return m.id === sel.id || (mPhone && selPhone && mPhone === selPhone);
      })
    );

    if (existingConv) {
      const contactMember = existingConv.members?.[0];
      handleClickConversation(existingConv, contactMember);
      setSelectedNewContact(null);
      return;
    }
    const tempId = `temp_${sel.attrs.id || selPhone || Date.now()}`;
    const tempConv = {
      id: tempId,
      members: [
        {
          id: sel.attrs.id,
          name: sel.attrs.name || sel.fullName,
          phone_number: sel.attrs.phoneNumber || sel.phone || sel.attrs.phone_number,
        },
      ],
      latest_message: null,
      new_message_count: 0,
      _isTemp: true,
    };
    setConversations((prev) => {
      if (prev.some((c) => c.id === tempConv.id)) return prev;
      return [tempConv, ...prev];
    });
    setSelectedConversationId(tempConv.id);
    setMembers(tempConv.members[0]);
    setMessages([]);
    setMessagesHasPrev(false);
    setMessagesPage(1);
    setContactId(sel.attrs.id);
    setContactName(sel.attrs.name || sel.fullName || sel.phoneNumber);
    setOpen(false);
    setSelectedNewContact(null);
  }, [selectedNewContact, conversations]);
  
  function transformMessages(data) {  
  return data.map((msg) => {
    let isUser;
    if (msg.message_order === "send") {
      isUser = "user";
    } else if (msg.message_order === "receive") {
      isUser = "receive";
    }  else if (msg.message_order === "bot") {
      isUser = "system";
    }

    let buttons;
    let listName;
    let header = null;
    let headerType = null;
    let footer = "";

    if (msg.template?.template_type === 'template') {
      const rawHeader = msg.template?.content?.header;
      if (rawHeader) {
        if (typeof rawHeader === "string") {
          header = rawHeader;
          headerType = "text";
        } else if (typeof rawHeader === "object") {
          header = rawHeader;
          headerType = "media";
        }
      }
      footer = msg.template?.content?.footer;
      if (msg.template?.content?.buttons?.length > 0) {
        const buttonArray = msg.template?.content?.buttons;
        buttons = buttonArray.map((btn) => ({
          btn_label: btn.label,
          btn_value: btn.value,
        }))
      }
    } else if (msg.template?.template_type === 'interactive' || msg.template?.template_type === 'flow') {
      const rawHeader = msg.template?.content?.header;
      if (rawHeader) {
        if (typeof rawHeader === "string") {
          header = rawHeader;
          headerType = "text";
        } else if (typeof rawHeader === "object") {
          header = rawHeader;
          headerType = "media";
        }
      }
      footer = msg.template?.content?.footer;
      if (msg.template?.content?.buttons?.length > 0) {
        const buttonArray = msg.template?.content?.buttons;
        buttons = buttonArray.map((btn) => ({
          btn_label: btn.name,
          btn_value: btn.id,
        }))
      } else if (msg.template?.content?.list?.list_row?.length > 0) {
        listName = msg.template?.content?.list?.button_text;
      }
    }
    let callMeta = null;
    if (msg.message_type === "call" && msg.context) {
      try {
        callMeta = JSON.parse(msg.context);
      } catch (e) {
        callMeta = null;
      }
    }

    let orderDetails = null;
    if (msg.message_type === "order" && msg.context) {
      try {
        const ctx = JSON.parse(msg.context);
        const catalogId = ctx.catalog_id;
        const productItems = ctx.product_items || [];
        const currency = productItems[0]?.currency || "";
        const totalPrice = productItems.reduce((sum, item) => sum + (item.item_price * item.quantity), 0);

        orderDetails = {
          catalogId,
          itemsCount: productItems.length,
          currency,
          totalPrice,
        };
      } catch (e) {
        // fallback if parsing fails
      }
    }
    let content = "";
    if (msg.message_type === "call" && callMeta) {
      content = callMeta;
    } else if (msg.message_type === "order" && orderDetails) {
      content = orderDetails;
    } else {
      content =
        msg.template?.content?.body ||
        (msg.context ? msg.context.replace(/\\n/g, "\n") : "") ||
        msg.template?.text ||
        "";
    }

    return {
      id: msg.id,
      type: isUser,
      header,
      headerType,
      footer,
      content,
      buttons,
      listName,
      mediaUrl: msg.media_url,
      media_type: msg.media_type,
      replyId: msg.reply_id,
      wamid: msg.wamid,
      timestamp: msg.created_at,
      message_type: msg.message_type,
      user_reaction: msg.sent_reaction,
      receive_reaction: msg.receive_reaction,
      status: msg.status,
      error_message: msg.error_message,
      error_code: msg.error_code,
    };
  });
};
async function fetch(isSearch = false, pageOverride = null) {
  try {
    setLoading(true);
      const currentPage = pageOverride || page;
      setLimit(limit);
      if (isSearch) {
        setConversations([]);
      }
      const isAssignedToMeFilter = assignmentStatusFilter === "assigned_to_me";
      if (isAssignedToMeFilter && !currentAccountId) {
        setConversations([]);
         setUnreadCount(0);
        setHasNext(false);
        return [];
      }
      const dbAssignmentStatus = FILTER_TO_DB_MAP[assignmentStatusFilter] || null;
      const response = await ConversationService.getConversations({
        page: currentPage,
        limit: limit,
        searchKey: searchKey?.trim(),
        // assignment_status: ["assigned", "queued", "unassigned", "closed", "assigned_to_me"].includes(assignmentStatusFilter)
        //   ? (isAssignedToMeFilter ? "assigned" : assignmentStatusFilter)
        //   : null,
        assignment_status: dbAssignmentStatus,
        assignee_account_id: isAssignedToMeFilter ? currentAccountId : null,
      });
      TagService.getAllTags().then((res) => setAvailableTags(res));
      const newConversations = Array.isArray(response?.data)
        ? response.data
        : Array.isArray(response)
          ? response
          : [];
      const pagination = response?.pagination || {};
      if (newConversations.length === 0 && searchKey?.trim()) {
        setConversations([]);
        setHasNext(false);
      setPage(1);
      setUnreadCount(0); 
      } else if (searchKey?.trim() && newConversations.length > 0) {
        setConversations([]);
        setConversations(newConversations);
        setHasNext(false);
        const count = calculateUnreadCount(newConversations);
       setUnreadCount(count);
      } else {
      setConversations((prev) => {
        const combined = [...(currentPage === 1 ? [] : prev), ...newConversations];
        const uniqueConversationsMap = new Map();
          combined.forEach(conv => {
        uniqueConversationsMap.set(conv.id, conv);
  });
  const result =  Array.from(uniqueConversationsMap.values());
  const count = calculateUnreadCount(result);
    setUnreadCount(count);
    return result;
});
      setHasNext(Boolean(pagination.hasNext));
      setPage((pagination.page || currentPage) + 1);
}
setSending(false);
setLoading(false);
    return newConversations;
    } catch (error) {
      console.error("Failed to fetch conversations:", error);
      return [];
    } finally {
      setLoading(false);
    }
}

  const fetchConversations = useCallback(async () => {
    if (loading || !hasNext) return;

    setLoading(true);
    fetch();
  }, [page, hasNext]);


  useEffect(() => {
    setConversations([]);
  setPage(1);
  setHasNext(true);
  fetch(true, 1);
  }, [searchKey, assignmentStatusFilter, currentAccountId]);

  const loadStaffForRouting = async () => {
    try {
      const s = await ConversationService.getRoutingStaff();
      console.log('s', s);
      
      setStaffForAssign(Array.isArray(s) ? s : []);
    } catch (e) {
      setStaffForAssign([]);
    }
  };

  useEffect(() => {
    (async () => {
      try {
        const account = await MyAccountService.fetch();
        setCurrentAccountId(account?.getId?.() || null);
        setCurrentAccountType(account?.getType?.() || null);
      } catch (e) {
        setCurrentAccountId(null);
        setCurrentAccountType(null);
      }
      try {
        const p = await ConversationService.getRoutingPolicy();
        if (p && typeof p === "object") {
          setRoutingPolicy(p);
        }
      } catch (e) {
        /* non-fatal */
      }
      await loadStaffForRouting();
    })();
  }, []);
  
  useEffect(() => {
    fetchConversations();
    MessageTemplateService.getAllTemplates().then((res) => setApprovedTemplates(res));
  }, []);

  useEffect(() => {
  const fetchWhatsappDetails = async () => {
    try {
      const whatsapp = await servicesService.getWhatsapp();
      if (whatsapp && whatsapp.phoneNumberId) {
        setPhoneNumberId(whatsapp.phoneNumberId);
      }
    } catch (error) {
      console.error('Failed to get WhatsApp details:', error);
    }
  };
  fetchWhatsappDetails();
}, []);


  const observer = useRef();
  const lastConversationRef = useCallback(
    (node) => {
      if (loading) return;
      if (observer.current) observer.current.disconnect();

      observer.current = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting && hasNext) {
          fetchConversations();
        }
      });

      if (node) observer.current.observe(node);
    },
    [hasNext, fetchConversations]
  );

  async function handleAddTag() {
    const matchedTag = availableTags.find(
      (tag) => tag.getName() === newTag.trim()
    );
  
    if (
      newTag.trim() &&
      matchedTag &&
      !members.tags?.find((t) => t.id === matchedTag.getId())
    ) {

      const updatedTags = [
      ...members.tags,
      {
        id: matchedTag.getId(),
        name: matchedTag.getName(),
        color: matchedTag.getColor(),
      },
    ];

    setFormData((prev) => ({
      ...prev,
      tags: updatedTags,
    }));
    setMembers((prev) => ({
      ...prev,
      tags: updatedTags
    }))

    await ContactApiService.assignTagToContact(contactId, updatedTags);
      setNewTag("");
    }
  };

  async function handleRemoveTag(tagIdToRemove) {
  const updatedTags = members.tags?.filter(tag => tag.id !== tagIdToRemove);

  setMembers(prev => ({
    ...prev,
    tags: updatedTags,
  }));

  setFormData(prev => ({
    ...prev,
    tags: updatedTags,
  }));

  await ContactApiService.assignTagToContact(contactId, updatedTags);
}

    function getTagColor(color) {
    return color || "#757575";
  };

    function handleKeyPress(event) {
    if (event.key === "Enter") {
      event.preventDefault();
      handleAddTag();
    }
  };

  async function handleClickConversation(chat, contact) {
    const container = messageContainerRef.current;
    let response;
    let targetConversationId = selectedConversationId;
    if (chat && contact) {
      setSelectedChat(chat);
      setMembers(contact);
      setSelectedConversationId(chat.id);
      targetConversationId = chat.id;
      setMessages([]);
      setMessagesPage(1);
      setMessagesHasPrev(true);
      setContactId(contact?.id);
      setContactName(contact?.name);
      setContactEmail(contact?.email);
      setTimer(chat.window_time);
      if (window.innerWidth < 900) {
        setShowChatListMobile(false);
        setShowContactMobile(false);
      }
      response = await ConversationService.getMessagesByConversation({
        page: 1,
        limit: 10,
        id: chat.id
      });
    } else {
      response = await ConversationService.getMessagesByConversation({
        page: 1,
        limit: 10,
        id: selectedConversationId
      });
      console.log('API Response:', response.data[0]);
    }
    let assignmentEvents = [];
    if (targetConversationId) {
      try {
        const events = await ConversationService.getAssignmentHistory(targetConversationId);
        assignmentEvents = Array.isArray(events)
          ? events
          : Array.isArray(events?.data)
            ? events.data
            : [];
      } catch (e) {
        assignmentEvents = [];
      }
    }
    const eventMessages = assignmentEvents.map((ev) => ({
      id: `evt_${ev.id}`,
      message_order: "bot",
      message_type: "system",
      context: ev.event_type === "assigned"
        ? `Chat is assigned to ${ev.to_account_name || resolveStaffName(ev.to_account_id) || "agent"}`
        : ev.event_type === "reassigned"
          ? `Chat is reassigned to ${ev.to_account_name || resolveStaffName(ev.to_account_id) || "agent"}`
          : ev.event_type === "claimed"
            ? `Chat is claimed by ${ev.actor_account_name || ev.to_account_name || resolveStaffName(ev.to_account_id || ev.actor_account_id) || "agent"}`
            : ev.event_type === "unassigned"
              ? "Chat is unassigned"
              : ev.event_type === "closed"
                ? "Chat is closed"
              : `Chat ${ev.event_type}`,
      created_at: ev.created_at,
    }));
    const baseMessages = Array.isArray(response)
      ? response
      : Array.isArray(response?.data)
        ? response.data
        : Array.isArray(response?.messages)
          ? response.messages
          : [];
    const merged = [...baseMessages, ...eventMessages]
      .sort((a, b) => new Date(b.created_at) - new Date(a.created_at));
    const newMessages = transformMessages(merged);
    const messagesWithDividers = insertDateDividers(newMessages.reverse());
    setMessages(messagesWithDividers);
    lastActionRef.current = "initial";
    setTimeout(() => scrollToBottom("auto"), 1);
  }

  const refreshConversationList = async () => {
    setConversations([]);
    setPage(1);
    setHasNext(true);
    const refreshed = await fetch(true, 1);
    if (selectedConversationId) {
      const matched = (refreshed || []).find((c) => c.id === selectedConversationId);
      const contact = matched?.members?.[0]?.contact;
      if (matched && contact) {
        await handleClickConversation(matched, contact);
      }
    }
  };

  const handleClaimInbox = async () => {
    if (!canManageAssignments) {
      showSnackbar("Only owner/admin can manage assignment.");
      return;
    }
    if (!selectedConversationId) return;
    setAssignBusy(true);
    try {
      await ConversationService.claimConversation(selectedConversationId);
      setMessages((prev) => insertDateDividers([
        ...prev.filter((m) => m.type !== "date-divider"),
        {
          id: `evt_local_claim_${Date.now()}`,
          type: "system",
          content: "Chat is claimed",
          timestamp: new Date().toISOString(),
          message_type: "system",
        },
      ]));
      await refreshConversationList();
    } catch (e) {
      console.error("Claim failed", e);
    } finally {
      setAssignBusy(false);
    }
  };

  const handleUnassignInbox = async () => {
    if (!canManageAssignments) {
      showSnackbar("Only owner/admin can manage assignment.");
      return;
    }
    if (!selectedConversationId) return;
    setUnassignDialogOpen(true);
  };

  const handleConfirmUnassign = async () => {
    if (!selectedConversationId) return;
    setUnassignDialogOpen(false);
    setAssignBusy(true);
    try {
      await ConversationService.unassignConversation(selectedConversationId);
      setMessages((prev) => insertDateDividers([
        ...prev.filter((m) => m.type !== "date-divider"),
        {
          id: `evt_local_unassign_${Date.now()}`,
          type: "system",
          content: "Chat is unassigned",
          timestamp: new Date().toISOString(),
          message_type: "system",
        },
      ]));
      await refreshConversationList();
    } catch (e) {
      console.error("Unassign failed", e);
    } finally {
      setAssignBusy(false);
    }
  };

  const handleCloseInbox = async () => {
    if (!canManageAssignments) {
      showSnackbar("Only owner/admin can close chats.");
      return;
    }
    if (!selectedConversationId) return;
    setCloseDialogOpen(true);
  };

  const handleConfirmClose = async () => {
    if (!selectedConversationId) return;
    setCloseDialogOpen(false);
    setAssignBusy(true);
    try {
      await ConversationService.closeConversation(selectedConversationId);
      setMessages((prev) => insertDateDividers([
        ...prev.filter((m) => m.type !== "date-divider"),
        {
          id: `evt_local_close_${Date.now()}`,
          type: "system",
          content: "Chat is closed",
          timestamp: new Date().toISOString(),
          message_type: "system",
        },
      ]));
      await refreshConversationList();
    } catch (e) {
      console.error("Close failed", e);
    } finally {
      setAssignBusy(false);
    }
  };

  const handleConfirmAssign = async () => {
    if (!canManageAssignments) {
      showSnackbar("Only owner/admin can manage assignment.");
      return;
    }
    if (!selectedConversationId || !assignTargetId) return;
    setAssignBusy(true);
    try {
      const fn = selectedChat?.current_assignee_account_id
        ? ConversationService.reassignConversation
        : ConversationService.assignConversation;
      await fn(selectedConversationId, assignTargetId);
      const assigneeName = resolveStaffName(assignTargetId) || "agent";
      setMessages((prev) => insertDateDividers([
        ...prev.filter((m) => m.type !== "date-divider"),
        {
          id: `evt_local_assign_${Date.now()}`,
          type: "system",
          content: selectedChat?.current_assignee_account_id
            ? `Chat is reassigned to ${assigneeName}`
            : `Chat is assigned to ${assigneeName}`,
          timestamp: new Date().toISOString(),
          message_type: "system",
        },
      ]));
      setAssignDialogOpen(false);
      setAssignTargetId(null);
      await refreshConversationList();
    } catch (e) {
      console.error("Assign failed", e);
    } finally {
      setAssignBusy(false);
    }
  };

  const scrollToBottom = (behavior = "auto") => {
    const c = messageContainerRef.current;
    if (!c) return;
    requestAnimationFrame(() => {
      c.scrollTo({ top: c.scrollHeight, behavior });
    });
  };

  function handleImageIconClick() {
    setImageDialogOpen(true);
    setCaption("");
    setSelectedImage(null);
  }

  function openImageViewer(url, caption = "") {
    if (!url) return;
    setImageViewer({ open: true, url, caption: caption || "" });
  }

  function closeImageViewer() {
    setImageViewer({ open: false, url: "", caption: "" });
  }

  // function handleImageChange(e) {
  //   const file = e.target.files?.[0];
  //   if (!file) return;
  //   const allowedTypes = ["image/jpeg", "image/png"];
  //   if (!allowedTypes.includes(file.type)) {
  //     alert("Invalid audio format. Allowed: .jpeg, .png");
  //     return;
  //   }
  //   if (file.size > 2 * 1024 * 1024) {
  //     alert("Image file size must be less than 2MB");
  //     return;
  //   }
  //   setSelectedImage(file);
  // }
  function handleAudioIconClick() {
    setAudioDialogOpen(true);
    setSelectedAudio(null);
  }
  // function handleAudioChange(e) {
  //   const file = e.target.files?.[0];
  //   if (!file) return;
  //   const allowedTypes = ["audio/aac", "audio/amr", "audio/mp3", "audio/mpeg", "audio/x-m4a", "audio/m4a, audio/mp4"];
  //   if (!allowedTypes.includes(file.type)) {
  //     alert("Invalid audio format. Allowed: .aac, .amr, .mp3, .m4a");
  //     return;
  //   }
  //   if (file.size > 10 * 1024 * 1024) {
  //     alert("Audio file size must be less than 10MB");
  //     return;
  //   }
  //   setSelectedAudio(file);
  // }
  useEffect(() => {
    const c = messageContainerRef.current;
    if (!c) {
      setShowScrollToBottom(false);
      return;
    }
    const onScroll = () => {
      const distanceFromBottom = c.scrollHeight - c.scrollTop - c.clientHeight;
      setShowScrollToBottom(distanceFromBottom > 20);
    };
    onScroll();
    c.addEventListener("scroll", onScroll);
    return () => c.removeEventListener("scroll", onScroll);
  }, [messages, messagesLoading, selectedConversationId]);

  const handleScrollToBottom = () => {
    scrollToBottom("smooth");
    setShowScrollToBottom(false);
  };
  useEffect(() => {
    if (!messages || messages.length === 0) return;
    if (lastActionRef.current === "initial") {
      scrollToBottom("auto");
      lastActionRef.current = null;
    }
  }, [messages, selectedConversationId]);

  useEffect(() => {
  if (!container) return;  
  const handleScroll = async () => {
    const oldestMessage = messages
  .filter(msg => msg.timestamp)
  .sort((a, b) => new Date(a.timestamp) - new Date(b.timestamp))[0];
    if (container.scrollTop <= 10 && messagesHasPrev && !messagesLoading) {
      setMessagesLoading(true);
      const nextPage = messagesPage + 1;
      const response = await ConversationService.getMessagesByConversation({
        // page: nextPage,
        limit: 10,
        id: selectedConversationId,
        before: oldestMessage?.timestamp ? oldestMessage?.timestamp : null,
      });
      const newMessages = transformMessages(response.data || []);
      if (oldestMessage) {
      setMessages((prev) => {
       const combined = [...newMessages.reverse(), ...prev]
      const uniqueMessagesMap = new Map();
          combined.forEach(conv => {
        uniqueMessagesMap.set(conv.id, conv);
      });
      const dateFormated = Array.from(uniqueMessagesMap.values())
      return insertDateDividers(dateFormated);
});
    }
      setMessagesPage(nextPage);
      setMessagesHasPrev(response.pagination?.hasPrev || false);
      setMessagesLoading(false);
      container.scrollTop = 50;
    }
  };

  container.addEventListener("scroll", handleScroll);
  return () => container.removeEventListener("scroll", handleScroll);
}, [messagesPage, selectedConversationId, messagesHasPrev, messagesLoading, messages]);

const handleInputChange = (field, value) => {
    setFormData((prev) => ({
      ...prev,
      [field]: value,
    }));
    if (errors[field]) {
      setErrors((prev) => ({
        ...prev,
        [field]: "",
      }));
    }
    if (field === "selectedTemplate") {
      const selected = approvedTemplates.find(t => t.getId() === value);
      let variableSamples = { header: {}, body: {}, footer: {} };
      try {
        variableSamples = selected ? JSON.parse(selected.attrs.variableSamples) : { header: {}, body: {}, footer: {} };
      } catch (e) {}
      setTemplateVariables({
        header: Object.fromEntries(Object.keys(variableSamples.header || {}).map(k => [k, ""])),
        body: Object.fromEntries(Object.keys(variableSamples.body || {}).map(k => [k, ""])),
        footer: Object.fromEntries(Object.keys(variableSamples.footer || {}).map(k => [k, ""])),
      });
      setTemplateMediaHeaderUrl("");
    }
  };

  const handleCloseTemplateDialog = () => {
    setTemplateDialogOpen(false);
    setTemplateMediaHeaderUrl("");
  };

  async function handleSave(){
    const selectedTpl = approvedTemplates.find((t) => t.getId() === formData.selectedTemplate);
    if (selectedTpl?.attrs?.headerType === "media") {
      const u = (templateMediaHeaderUrl || "").trim();
      if (!/^https:\/\//i.test(u)) {
        setErrors((prev) => ({
          ...prev,
          templateMediaHeader:
            "Upload header media or enter a public HTTPS URL for this template.",
        }));
        showSnackbar("Add a valid HTTPS URL for the template header media.", "error");
        return;
      }
    }
    let convoId;
    if (selectedConversationId?.startsWith('temp_')) {
      convoId = null
    } else {
      convoId = selectedConversationId;
    }
    const variablesPayload = {
      ...templateVariables,
      ...(selectedTpl?.attrs?.headerType === "media"
        ? { media_header_url: (templateMediaHeaderUrl || "").trim() }
        : {}),
    };
    const messagePayload = {
          conversation_id: convoId,
          message: message.trim(),
          contact_id: contactId,
          message_type: 'text',
          template_id: formData.selectedTemplate,
          variables: variablesPayload,
        }
        await ConversationService.sendMessage(messagePayload);
        setFormData({ selectedTemplate: "" });
        setTemplateVariables({ header: {}, body: {}, footer: {} });
        setTemplateMediaHeaderUrl("");
        setErrors((prev) => ({ ...prev, templateMediaHeader: "" }));
        handleCloseTemplateDialog();
  };

  function handleOpenContacts() {
     setOpen(true);
  }
  function handleStopRecording() {
    stopMicrophone();
    mediaRecorderRef.current?.stop();
  setIsRecording(false);
  }
  async function handleStartRecording() {
   try {
    const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
    setMediaStream(stream);
    const mediaRecorder = new MediaRecorder(stream, {
  mimeType: "audio/webm;codecs=opus"
});
    mediaRecorderRef.current = mediaRecorder;
    audioChunksRef.current = [];

    mediaRecorder.ondataavailable = (event) => {
      if (event.data.size > 0) {
        audioChunksRef.current.push(event.data);
      }
    };

    mediaRecorder.onstop = () => {
      const audioBlob = new Blob(audioChunksRef.current, {
        type: "audio/webm",
      });
      setRecordedAudio(audioBlob);
    };

    mediaRecorder.start();
    setIsRecording(true);
  } catch (err) {
    console.error("Microphone access denied", err);
  }
  }

  function handleEmojiClick(emoji) {
    if (reactingWamid) {
      handleSendReaction(emoji.native, reactingWamid);
      setReactingWamid(null);
      setEmojiDialogOpen(false);
      return;
    }
    setMessage(`${message}${emoji.native}`);
    setEmojiDialogOpen(false);
  };

  async function handleSendReaction(emoji, wamid) {
    if (!emoji || !wamid) return;
    try {
      await ConversationService.sendReaction({ wamid, emoji, contactId: contactId });
    } catch (error) {
      console.error("Failed to send reaction:", error);
    }
  }

  function renderSendTemplate() {
    const selected = approvedTemplates.find(t => t.getId() === formData.selectedTemplate);
    let variableSamples = { header: {}, body: {}, footer: {} };
    try {
      variableSamples = selected ? JSON.parse(selected.attrs.variableSamples) : { header: {}, body: {}, footer: {} };
    } catch (e) {}
    return (
      <Box sx={{ display: "flex", flexDirection: "column", gap: 3 }}>
        <Card sx={{ border: "1px solid #e0e0e0", borderRadius: 2 }}>
          <CardContent sx={{ p: 3 }}>
            <Typography
              variant="h6"
              sx={{ fontWeight: 600, color: "#333", mb: 2, fontFamily: "'Poppins', sans-serif"}}
            >
              Select Templates
            </Typography>

            <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>

              <FormControl
                fullWidth
                size="small"
                error={!!errors.selectedTemplate}
              >
                <InputLabel>Select Template</InputLabel>
                <Select
                  value={formData.selectedTemplate}
                  onChange={(e) =>
                    handleInputChange("selectedTemplate", e.target.value)
                  }
                  label="Select Template"
                >
                  {approvedTemplates.map((template) => (
                    <MenuItem key={template.getId()} value={template.getId()}>
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "flex-start",
                        }}
                      >
                        <Typography variant="body2" sx={{ fontWeight: 500 }}>
                          {template.getTemplateName()}
                        </Typography>
                        <Typography variant="caption" color="text.secondary">
                          {template.getCategory()} • {template.getLanguage()}
                        </Typography>
                      </Box>
                    </MenuItem>
                  ))}
                </Select>
                {errors.selectedTemplate && (
                  <Typography
                    variant="caption"
                    color="error"
                    sx={{ mt: 0.5, ml: 1.5 }}
                  >
                    {errors.selectedTemplate}
                  </Typography>
                )}
              </FormControl>

              {selected?.attrs?.headerType === "media" ? (
                <Box sx={{ display: "flex", flexDirection: "column", gap: 1, mt: 1 }}>
                  <Typography variant="subtitle2" sx={{ fontWeight: 500 }}>
                    Header media
                  </Typography>
                  <Typography variant="caption" color="text.secondary">
                    Meta fetches this URL when the message is sent. Upload or paste an HTTPS link.
                  </Typography>
                  <input
                    ref={teamTemplateHeaderFileRef}
                    type="file"
                    hidden
                    accept={
                      selected?.attrs?.headerMediaType === "video"
                        ? "video/*"
                        : selected?.attrs?.headerMediaType === "document"
                          ? "application/pdf,.pdf"
                          : "image/jpeg,.jpg,.jpeg,image/png,.png"
                    }
                    onChange={async (e) => {
                      const file = e.target.files?.[0];
                      if (e.target) e.target.value = "";
                      if (!file) return;
                      const mediaType = selected?.attrs?.headerMediaType || "image";
                      const limit = HEADER_MEDIA_SIZE_LIMITS[mediaType];
                      if (limit && file.size > limit) {
                        const sizeMb = Math.floor(limit / (1024 * 1024));
                        setErrors((prev) => ({
                          ...prev,
                          templateMediaHeader: `${mediaType} size must be ${sizeMb} MB or less (Meta limit).`,
                        }));
                        return;
                      }
                      setTemplateHeaderMediaUploading(true);
                      try {
                        const result = await MessageTemplateService.uploadMediaNode(file);
                        const url = result?.data?.[0]?.url;
                        if (url) {
                          setTemplateMediaHeaderUrl(url);
                          setErrors((prev) => ({ ...prev, templateMediaHeader: "" }));
                        }
                      } catch (err) {
                        console.error(err);
                      } finally {
                        setTemplateHeaderMediaUploading(false);
                      }
                    }}
                  />
                  <Button
                    variant="outlined"
                    size="small"
                    disabled={templateHeaderMediaUploading}
                    onClick={() => teamTemplateHeaderFileRef.current?.click()}
                    sx={{ alignSelf: "flex-start" }}
                  >
                    {templateHeaderMediaUploading ? "Uploading…" : "Upload file"}
                  </Button>
                  <TextField
                    label="HTTPS URL"
                    value={templateMediaHeaderUrl}
                    onChange={(e) => {
                      setTemplateMediaHeaderUrl(e.target.value);
                      if (errors.templateMediaHeader) {
                        setErrors((prev) => ({ ...prev, templateMediaHeader: "" }));
                      }
                    }}
                    error={!!errors.templateMediaHeader}
                    helperText={errors.templateMediaHeader || "Required for media header templates"}
                    fullWidth
                    size="small"
                  />
                </Box>
              ) : null}

              {/* Variable input fields for header/body/footer */}
              {["header", "body", "footer"].map((section) => (
                variableSamples[section] && Object.keys(variableSamples[section]).length > 0 && (
                  <Box key={section} sx={{ display: "flex", flexDirection: "column", gap: 1, mt: 1 }}>
                    <Typography variant="subtitle2" sx={{ fontWeight: 500 }}>
                      {section.charAt(0).toUpperCase() + section.slice(1)} Variables
                    </Typography>
                    {Object.keys(variableSamples[section]).map((key) => (
                      <TextField
                        key={key}
                        label={`Value for {{${key}}}`}
                        value={templateVariables[section][key] || ""}
                        onChange={(e) =>
                          setTemplateVariables((prev) => ({
                            ...prev,
                            [section]: {
                              ...prev[section],
                              [key]: e.target.value,
                            },
                          }))
                        }
                        error={!!errors[`var_${section}_${key}`]}
                        helperText={errors[`var_${section}_${key}`] || `Enter value for {{${key}}}`}
                        fullWidth
                        size="small"
                      />
                    ))}
                  </Box>
                )
              ))}
            </Box>
          </CardContent>
        </Card>
      </Box>
    );
  };

  const ReactionButton = ({ onClick }) => (
  <IconButton
    size="small"
    sx={{
      p: 0.5,
      color: "#6b7280",
      alignSelf: "center",
    }}
    onClick={onClick}
  >
    <InsertEmoticonIcon fontSize="small" />
  </IconButton>
);

  function findMessageById(id) {
    const message = messages.find(
    (msg) => msg.wamid === id
  );
  return message;
};
function handleSearch(value) {
  if(value) {
    setPage(1);
    setSearchKey(value)
  } else {
     setSearchKey(null)
  }
}
const ReactionChip = ({ reactions, align = "right" }) => {
  if (!reactions.length) return null;

  return (
    <Box
      sx={{
        position: "absolute",
        bottom: -10,
        ...(align === "right"
          ? { right: 12 }
          : { left: 12 }),
        bgcolor: "#fff",
        borderRadius: 20,
        px: 0.8,
        py: 0.2,
        display: "flex",
        alignItems: "center",
        gap: 0.5,
        boxShadow: "0 1px 3px rgba(0,0,0,0.25)",
        border: "1px solid #e5e7eb",
        zIndex: 10,
      }}
    >
      {reactions.map((emoji, index) => (
        <Typography key={index} sx={{ fontSize: 14, lineHeight: 1 }}>
          {emoji}
        </Typography>
      ))}

      {reactions.length > 1 && (
        <Typography
          sx={{
            fontSize: 11,
            fontWeight: 600,
            color: "#4b5563",
          }}
        >
          {reactions.length}
        </Typography>
      )}
    </Box>
  );
};

function insertDateDividers(messages) {
  const result = [];
  let lastDate = null;

  for (const msg of messages) {
    if (msg.type !== "date-divider") {
    const msgDate = new Date(msg.timestamp);
    const today = new Date();
    const yesterday = new Date();
    yesterday.setDate(today.getDate() - 1);

    const msgDay = msgDate.toDateString();
    const todayStr = today.toDateString();
    const yesterdayStr = yesterday.toDateString();

    let label;

    if (msgDay === todayStr) {
      label = "Today";
    } else if (msgDay === yesterdayStr) {
      label = "Yesterday";
    } else {
      label = msgDate.toLocaleDateString(undefined, {
        day: "numeric",
        month: "short",
        year: "numeric",
      });
    }

    if (lastDate !== msgDay) {
      result.push({
        id: `divider-${msg.id}`,
        type: "date-divider",
        content: label,
      });
      lastDate = msgDay;
    }

    result.push(msg);
  }
}

  return result;
}

const { incomingCall, clearIncomingCall } = useIncomingCall(
  appConfig.getServiceId(),
  !!phoneNumberId
);

  return (
    <Box
      sx={{
        display: "flex",
        height: "100%",
        bgcolor: WA_THEME.appBg,
        overflow: "hidden",
        fontFamily: `"Poppins", sans-serif`,
        // flexDirection: { xs: "column", md: "row" },
      }}
    >
      {/* Chat List Section */}
      <InboxColumn showChatListMobile={showChatListMobile}>
        {/* Search & Header */}
       <Box
  sx={{
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    p: 1,
    gap: 1,
    position: "sticky",
    top: 0,
    zIndex: 4,
    bgcolor: "#fff",
    borderBottom: "1px solid #eef2f7",
  }}
>


  {/* Search Box */}
  <TextField
            fullWidth
            placeholder="Search"
            size="small"
            onChange={(e) => handleSearch(e.target.value || null)}
            sx={{ "& .MuiOutlinedInput-root": { borderRadius: 2.5, bgcolor: "#f8fafc", height: 36 } }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon />
                </InputAdornment>
              ),
            }}
          />
  {/* New Message Button */}
<IconButton
  onClick={handleOpenContacts}
   size="small"
  sx={{
    width: 32,
    height: 32,
    bgcolor: WA_THEME.primary,
    color: "#fff",
    "&:hover": {
      bgcolor: WA_THEME.primaryDark,
    },
  }}
>
  <AddIcon fontSize="small" />
</IconButton>
 <MissedCallNotification 
    serviceId={appConfig.getServiceId()}
    contactId={null}
  />
<>
  <IconButton
    size="small"
     onClick={handleFilterMenuClick}
    sx={{
      width: 36,
      height: 36,
      border: "1px solid #e5e7eb",
      color: assignmentStatusFilter ? "#22c55e" : "#64748b",
      bgcolor: assignmentStatusFilter ? "#ecfdf5" : "transparent",
    }}
  >
  <FilterListIcon fontSize="small" />
  </IconButton>

  {/* Dropdown Menu */}
  <Menu
    anchorEl={filterAnchorEl}
    open={filterMenuOpen}
     onClose={handleFilterMenuClose} 
    PaperProps={{
      sx: {
        mt: 1,
        minWidth: 200,
        borderRadius: 2,
        boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
        maxHeight: 400,
      }
    }}
  >
   {inboxQuickFilters.map((filter) => {
  const IconComponent = filter.icon;
  return (
    <MenuItem
      key={filter.id || "all"}
      onClick={() => {
        setAssignmentStatusFilter(filter.id);
        handleFilterMenuClose();
      }}
      selected={assignmentStatusFilter === filter.id}
      sx={{
        py: 1,
        px: 1.5,
        bgcolor: assignmentStatusFilter === filter.id ? "#ecfdf5" : "transparent",
        "&:hover": { bgcolor: "#f1f5f9" },
      }}
    >
      <Box sx={{ display: "flex", alignItems: "center", gap: 1.5, width: "100%" }}>
        <IconComponent fontSize="small" sx={{ fontSize: 18, color: filter.color }} />
        <Typography sx={{ flex: 1, fontSize: 14 }}>
          {filter.id === "unread" ? `Unread (${unreadCount})` : filter.label}
        </Typography>
        {assignmentStatusFilter === filter.id && (
          <CheckIcon fontSize="small" sx={{ color: "#22c55e" }} />
        )}
      </Box>
    </MenuItem>
  );
})}
    
  </Menu>
</>
</Box>

        <Box sx={{ px: 2, pb: 1 }}>
          <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 1 }}>
            <Typography sx={{ fontSize: 11, color: "#64748b", fontWeight: 700, textTransform: "uppercase", letterSpacing: 0.4 }}>
              Last 24 hours
            </Typography>
            <Typography sx={{ fontSize: 11, color: "#64748b", fontWeight: 500 }}>
              {visibleConversations.length} chats • {unreadCount} unread
            </Typography>
          </Box>
          <Box sx={{ display: "flex", gap: 0.75, flexWrap: "wrap", mb: 1 }}>
            {inboxQuickFilters.map((f) => (
              <Chip
                key={f.id || "all"}
                label={f.id === "unread" ? `Unread (${unreadCount})` : f.label}
                size="small"
                clickable
                color={assignmentStatusFilter === f.id ? "success" : "default"}
                variant={assignmentStatusFilter === f.id ? "filled" : "outlined"}
                onClick={() => setAssignmentStatusFilter(f.id)}
                sx={{ borderRadius: 2.5, fontWeight: 600,transition:"background-color 250ms ease, color 250ms ease, border-color 250ms ease", }}
              />
            ))}
          </Box>
          {/* <FormControl size="small" fullWidth>
            <InputLabel id="inbox-assignment-filter-label">Inbox</InputLabel>
            <Select
              labelId="inbox-assignment-filter-label"
              value={assignmentStatusFilter}
              label="Inbox"
              onChange={(e) => setAssignmentStatusFilter(e.target.value)}
            >
              <MenuItem value="">All chats</MenuItem>
              <MenuItem value="queued">Queued</MenuItem>
              <MenuItem value="assigned">Assigned</MenuItem>
              <MenuItem value="assigned_to_me">Assigned to me</MenuItem>
              <MenuItem value="unread">Unread</MenuItem>
              <MenuItem value="unassigned">Unassigned</MenuItem>
              <MenuItem value="closed">Closed</MenuItem>
            </Select>
          </FormControl> */}
        </Box>

        {/* All Chats Header */}
        <Box sx={{ px: 2 }}>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
             {/* <Typography variant="caption" color="text.secondary">
               New Chats • {conversations.length} 
             </Typography> */}
            {/* <Box>
              <IconButton size="small">
                <FilterIcon />
              </IconButton>
            </Box> */}
          </Box>
        </Box>
        {/* Conversations List */}
      <Box sx={{ flex: 1, overflowY: "auto", px: 0.25 }}>
       {visibleConversations.map((chat, index) => {
        const isLast = index === visibleConversations.length - 1;
        const ref = isLast ? lastConversationRef : null;
        const contact = chat.members?.[0];

       return (
        <Paper
        ref={ref}
        key={chat.id}
        onClick={() => handleClickConversation(chat, contact)}
        sx={{
          p: 1.25,
          mb: 0.4,
          mx: 0.75,
          cursor: "pointer",
          boxShadow: "0 1px 2px rgba(16,24,40,0.06)",
          position: "relative",
          borderRadius: 2,
          bgcolor: selectedConversationId === chat.id ? "#ecfdf3" : "#fff",
          border: selectedConversationId === chat.id ? "1px solid #86efac" : "1px solid #eef2f7",
          borderLeft: selectedConversationId === chat.id ? "3px solid #22c55e" : "3px solid transparent",
            "&:hover": {
             bgcolor: "#f8fafc",
           },
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center" }}>
          
          {/* Avatar */}
          <Box sx={{ position: "relative", mr: 1.5 }}>
            <Avatar sx={{ bgcolor: WA_THEME.primary, width: 44, height: 44 }}>
              {contact?.name
                ?.[0]
                ?.split(" ")
                ?.map((n) => n[0])
                ?.join("")
                ?.toUpperCase()}
            </Avatar>

            {/* Online Dot */}
            {/* <Box
              sx={{
                width: 10,
                height: 10,
                bgcolor: "#fbc02d",
                borderRadius: "50%",
                position: "absolute",
                bottom: 2,
                right: 2,
                border: "2px solid #fff",
              }}
            /> */}
          </Box>

          {/* Content */}
          <Box sx={{ flex: 1, minWidth: 0 }}>
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <Typography sx={{ fontWeight: 700, fontSize: 13.5,
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
              maxWidth: { xs: 210, md: 180 },
       }}>
                {contact?.name || "Customer name"}
              </Typography>
              <Typography
                variant="caption"
                sx={{
                  px: 0.8,
                  py: 0.15,
                  borderRadius: 1,
                  bgcolor: chat.new_message_count > 0
                    ? "#dbeafe"
                    : chat.assignment_status === "assigned"
                      ? "#dcfce7"
                      : "#fef3c7",
                  color: chat.new_message_count > 0
                    ? "#1e40af"
                    : chat.assignment_status === "assigned"
                      ? "#166534"
                      : "#92400e",
                  fontWeight: 700,
                  ml: 0.5,
                }}
              >
                {chat.new_message_count > 0 ? "Unread" : chat.assignment_status === "assigned" ? "Open" : "Pending"}
              </Typography>

              <Typography variant="caption" color="text.secondary">
                {chat?.updated_at
                  ? new Date(chat.updated_at).toLocaleTimeString([], {
                      hour: "2-digit",
                      minute: "2-digit",
                    })
                  : ""}
              </Typography>
            </Box>
            <Box sx={{ display: "flex", gap: 0.5, mb: 0.6, flexWrap: "wrap" }}>
              <Chip
                size="small"
                label={chat.assignment_status || "unassigned"}
                variant="outlined"
                color={chat.assignment_status === "assigned" ? "success" : "default"}
                sx={{ height: 20, fontSize: 10, textTransform: "capitalize" }}
              />
              <Chip
                size="small"
                label="WhatsApp"
                variant="outlined"
                sx={{ height: 20, fontSize: 10 }}
              />
            </Box>
            <Typography variant="caption" sx={{ color: "#64748b", display: "block", mb: 0.45, fontWeight: 500 }}>
              {chat.assignee?.name ? `Assigned to ${chat.assignee.name}` : "Not assigned"}
            </Typography>

         <Typography
  variant="caption"
  color="text.secondary"
  sx={{
    maxWidth: { xs: 250, md: 190 },
    display: "flex",
    alignItems: "center",
    gap: 0.5,
    overflow: "hidden",
    whiteSpace: "nowrap",
  }}
>
  {chat.latest_message?.message_type === "image" && (
    <ImageIcon sx={{ fontSize: 14, flexShrink: 0 }} />
  )}

  {chat.latest_message?.message_type === "audio" && (
    <AudiotrackOutlined sx={{ fontSize: 14, flexShrink: 0 }} />
  )}

  {chat.latest_message?.message_type === "video" && (
    <AudiotrackOutlined sx={{ fontSize: 14, flexShrink: 0 }} />
  )}

  {(chat.latest_message?.message_type === "file"
    || chat.latest_message?.message_type === "document") && (
    <AudioFile sx={{ fontSize: 14, flexShrink: 0 }} />
  )}

  <span
    style={{
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
    }}
  >
    {chat.latest_message?.message_type === "order"
      ? "Order Message"
      : chat.latest_message?.message_type === "call"
      ? getCallPreviewText(chat.latest_message?.context)
      : chat.latest_message?.message_type === "template"
      ? "Template Message"
      : chat.latest_message?.message_type === "interactive"
      ? "Interactive Message"
      : chat.latest_message?.message_type === "flow"
      ? "Flow Message"
      : chat.latest_message?.message_type === "image"
      ? "Image"
      : chat.latest_message?.message_type === "audio"
      ? "Audio"
      : chat.latest_message?.message_type === "video"
      ? "Video"
      : chat.latest_message?.message_type === "file"
      || chat.latest_message?.message_type === "document"
      ? "Document"
      : chat.latest_message?.message_type === "sticker"
      ? "Sticker"
      : chat.latest_message?.context || "No message yet"}
  </span>
</Typography>
          </Box>

          {/* Right Actions */}
          <Box
            sx={{
              minWidth: 38,
              display: "flex",
              alignItems: "center",
              justifyContent: "flex-end",
              pl: 1,
              pr: 0.5,
            }}
          >
            {chat.new_message_count > 0 && (
              <Box
                sx={{
                  bgcolor: "#fbc02d",
                  color: "#000",
                  fontSize: 12,
                  fontWeight: 600,
                  width: 22,
                  height: 22,
                  borderRadius: "50%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  flexShrink: 0,
                }}
              >
                {chat.new_message_count}
              </Box>
            )}

            {/* <Button
              size="small"
              variant="contained"
              sx={{
                textTransform: "none",
                borderRadius: 20,
                fontSize: 12,
                px: 2,
                bgcolor: "#e3ebff",
                color: "#3f5bd8",
                boxShadow: "none",
                "&:hover": { bgcolor: "#d6e0ff" },
              }}
            >
              Open
            </Button> */}
          </Box>
        </Box>
      </Paper>
    );
  })}

  {loading && (
    <Box sx={{ display: "flex", justifyContent: "center", py: 2 }}>
      <CircularProgress size={20}/>
    </Box>
  )}
</Box>
      </InboxColumn>

      {/* Middle Column - Chat Conversation (50%) */}
      <ChatColumn showChatListMobile={showChatListMobile}>
        {!selectedConversationId ? (
  /* ===== NO CHAT SELECTED PLACEHOLDER ===== */
  <Box
    sx={{
      flex: 1,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      flexDirection: "column",
      textAlign: "center",
      bgcolor: "#fcfdff",
      px: 2,
    }}
  >
     <ChatOutlinedIcon
    sx={{
      fontSize: 72,
      color: "#d1d5db",
      mb: 1.5,
    }}
  />
    <Typography
      sx={{
        fontSize: 18,
        fontWeight: 600,
        mb: 1,
        color: "#374151",
        fontFamily: `"Poppins", sans-serif`,
      }}
    >
      Select a conversation Or Create New Message
    </Typography>

    <Typography
      sx={{
        fontSize: 14,
        color: "#9ca3af",
        maxWidth: 300,
        fontFamily: `"Poppins", sans-serif`,
      }}
    >
      Choose a chat from the list to start messaging
    </Typography>
  </Box>
) : (
  /* ===== CHAT SELECTED VIEW ===== */
  <>
         {contactname !== '' && (
          <>
        {/* Chat Header */}
        <Box
          sx={{
            px: { xs: 1, md: 2 },
            py: { xs: 1, md: 2 },
            backgroundColor: "#fff",
            borderBottom: "1px solid #d8e0e5",
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: { xs: 0.5, md: 1 },
              minWidth: 0,
            }}
          >
            {/* Mobile back */}
            <IconButton
              size="small"
              onClick={() => {
                setShowContactMobile(false);
                setShowChatListMobile(true);
              }}
              sx={{ display: { xs: "inline-flex", md: "none" }, flexShrink: 0 }}
              aria-label="Back to chats"
            >
              <ArrowDownwardIcon sx={{ transform: "rotate(90deg)" }} />
            </IconButton>

            {/* Timer — compact on mobile, full ring on desktop */}
            {timeLeft === "Expired" ? (
              <Typography
                variant="caption"
                sx={{
                  flexShrink: 0,
                  mr: { xs: 0.5, md: 2 },
                  px: { xs: 0.75, md: 0 },
                  py: { xs: 0.25, md: 0 },
                  borderRadius: { xs: 1, md: 0 },
                  bgcolor: { xs: "#f3f4f6", md: "transparent" },
                  fontWeight: 600,
                  fontSize: 11,
                  fontFamily: `"Poppins", sans-serif`,
                  color: "#9e9e9e",
                }}
              >
                Expired
              </Typography>
            ) : (
              <>
                <Box
                  sx={{
                    position: "relative",
                    flexShrink: 0,
                    ml: { xs: 0, md: 4 },
                    mr: { xs: 0.5, md: 2 },
                    width: { xs: 40, md: 56 },
                    height: { xs: 40, md: 56 },
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <Box
                    sx={{
                      position: "absolute",
                      inset: 0,
                      borderRadius: "50%",
                      border: `2px solid ${WA_THEME.primary}`,
                    }}
                  />
                  <Box
                    sx={{
                      position: "absolute",
                      inset: { xs: 4, md: 5 },
                      borderRadius: "50%",
                      border: "2px solid #b8e7dd",
                    }}
                  />
                  <Typography
                    variant="caption"
                    sx={{
                      fontSize: { xs: 11, md: 14 },
                      fontWeight: 600,
                      color: WA_THEME.primary,
                      lineHeight: 1,
                    }}
                  >
                    {timeLeft}
                  </Typography>
                </Box>
              </>
            )}

            <Avatar
              sx={{
                bgcolor: WA_THEME.primary,
                width: { xs: 36, md: 42 },
                height: { xs: 36, md: 42 },
                flexShrink: 0,
              }}
            >
              <Typography
                variant="caption"
                sx={{ color: "white", fontSize: { xs: 20, md: 26 }, fontFamily: `"Poppins", sans-serif` }}
              >
                {contactname?.[0]}
              </Typography>
            </Avatar>

            <Box sx={{ flex: 1, minWidth: 0, mr: { xs: 0.5, md: 2 } }}>
              <Typography
                noWrap
                sx={{
                  fontSize: { xs: 15, md: 18 },
                  fontWeight: 500,
                  fontFamily: `"Poppins", sans-serif`,
                  lineHeight: 1.2,
                }}
              >
                {contactname}
              </Typography>
              <Typography
                noWrap
                sx={{
                  fontSize: 12,
                  color: "#757575",
                  fontFamily: `"Poppins", sans-serif`,
                  display: { xs: "none", md: "block" },
                }}
              >
                {contactemail}
              </Typography>
            </Box>

            {/* Header actions — always on the right */}
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: { xs: 0.25, md: 1 },
                flexShrink: 0,
                ml: "auto",
              }}
            >
              <Tooltip title="Contact info">
                <IconButton
                  size="small"
                  onClick={() => setShowContactMobile(true)}
                  aria-label="Contact info"
                  sx={{
                    display: { xs: "inline-flex", md: "none" },
                    color: WA_THEME.primary,
                    border: "1px solid #d8e0e5",
                    bgcolor: "#f8fafc",
                  }}
                >
                  <InfoOutlinedIcon fontSize="small" />
                </IconButton>
              </Tooltip>

              {selectedConversationId && (
                <>
                  {/* Mobile: icon-only assign + menu */}
                  <Tooltip
                    title={selectedChat?.current_assignee_account_id ? "Reassign" : "Assign"}
                  >
                    <span>
                      <IconButton
                        size="small"
                        disabled={
                          !canManageAssignments
                          || assignBusy
                          || selectedChat?.assignment_status === "closed"
                        }
                        onClick={async () => {
                          await loadStaffForRouting();
                          setAssignTargetId("");
                          setAssignDialogOpen(true);
                        }}
                        sx={{
                          display: { xs: "inline-flex", md: "none" },
                          color: "#fff",
                          bgcolor: WA_THEME.primary,
                          "&:hover": { bgcolor: WA_THEME.primaryDark },
                          "&.Mui-disabled": { bgcolor: "#e5e7eb", color: "#9ca3af" },
                        }}
                        aria-label="Assign conversation"
                      >
                        <AssignmentIndIcon fontSize="small" />
                      </IconButton>
                    </span>
                  </Tooltip>
                  <IconButton
                    size="small"
                    onClick={handleMenuClick}
                    disabled={!canManageAssignments || assignBusy}
                    sx={{ display: { xs: "inline-flex", md: "none" } }}
                    aria-label="More actions"
                  >
                    <MoreVertIcon fontSize="small" />
                  </IconButton>

                  {/* Desktop: text buttons */}
                  <Box
                    sx={{
                      display: { xs: "none", md: "flex" },
                      alignItems: "center",
                      gap: 1,
                      p: 0.5,
                      bgcolor: "#f8fafc",
                      borderRadius: 2,
                      border: "1px solid #e5e7eb",
                    }}
                  >
                    <Button
                      size="small"
                      variant="contained"
                      startIcon={<AssignmentIndIcon sx={{ fontSize: 18 }} />}
                      disabled={
                        !canManageAssignments
                        || assignBusy
                        || selectedChat?.assignment_status === "closed"
                      }
                      onClick={async () => {
                        await loadStaffForRouting();
                        setAssignTargetId("");
                        setAssignDialogOpen(true);
                      }}
                      sx={{
                        textTransform: "none",
                        fontWeight: 700,
                        px: 1.5,
                        borderRadius: 2,
                        bgcolor: "#0f6fff",
                        "&:hover": { bgcolor: "#0b5ed7" },
                      }}
                    >
                      {selectedChat?.current_assignee_account_id ? "Reassign" : "Assign"}
                    </Button>
                    <Button
                      size="small"
                      variant="outlined"
                      endIcon={<ArrowDropDownIcon />}
                      onClick={handleMenuClick}
                      disabled={!canManageAssignments || assignBusy}
                      sx={{
                        textTransform: "none",
                        fontWeight: 600,
                        borderColor: "#d6dce5",
                        color: "#334155",
                        px: 1.25,
                        borderRadius: 2,
                        bgcolor: "white",
                        "&:hover": { borderColor: "#c2ccd8", bgcolor: "#f8fafc" },
                      }}
                    >
                      Actions
                    </Button>
                  </Box>

                  <CallButton
                    serviceId={appConfig.getServiceId()}
                    contactId={contactId}
                    phoneNumber={members?.phone_number}
                    contactName={contactname}
                    variant="icon"
                    onCallEnded={() => setCallHistoryRefreshKey((key) => key + 1)}
                  />
                </>
              )}
            </Box>
          </Box>
          {selectedConversationId && (
            <Menu
              anchorEl={anchorEl}
              open={Boolean(anchorEl)}
              onClose={handleMenuClose}
            >
              <MenuItem
                onClick={() => {
                  handleMenuClose();
                  setShowContactMobile(true);
                }}
                sx={{ display: { xs: "flex", md: "none" } }}
              >
                <InfoOutlinedIcon sx={{ fontSize: 16, mr: 1 }} />
                Contact info
              </MenuItem>
              {routingPolicy?.allow_agent_claim !== false && (
                <MenuItem
                  disabled={!canManageAssignments || assignBusy || selectedChat?.assignment_status === "closed"}
                  onClick={async () => {
                    handleMenuClose();
                    await handleClaimInbox();
                  }}
                >
                  Claim
                </MenuItem>
              )}
              <MenuItem
                disabled={!canManageAssignments || assignBusy || !selectedChat?.current_assignee_account_id || selectedChat?.assignment_status === "closed"}
                onClick={() => {
                  handleMenuClose();
                  handleUnassignInbox();
                }}
              >
                Unassign
              </MenuItem>
              <MenuItem
                disabled={!canManageAssignments || assignBusy || selectedChat?.assignment_status === "closed"}
                onClick={() => {
                  handleMenuClose();
                  handleCloseInbox();
                }}
                sx={{ color: "#b42318" }}
              >
                <CheckCircleOutlineIcon sx={{ fontSize: 16, mr: 1 }} />
                Close conversation
              </MenuItem>
            </Menu>
          )}
        </Box>
        </>
        )}
        {/* Messages Area */}
        <Box
          ref={messageContainerRef}
          sx={{
            flex: 1,
            p: { xs: 1, md: 2 },
            overflow: "auto",
            position: "relative",
            minHeight: 0,
            ...WA_THEME.wallpaper,
            pb: { xs: 15, md: 0 },
          }}
        >
          {messagesLoading && (
            <Box sx={{ display: "flex", justifyContent: "center", py: 1 }}>
              <CircularProgress size={20} />
            </Box>
          )}
  {messages.map((msg) => {
    // Find replied message if any
    const repliedMsg = msg.replyId ? findMessageById(msg.replyId) : null;
    const reactions = [];
  if (msg.user_reaction) reactions.push(msg.user_reaction);
  if (msg.receive_reaction) reactions.push(msg.receive_reaction);

  const reactionCount = reactions.length;
  const hasImageMessage = msg.message_type === "image" && !!msg.mediaUrl;
  const hasVideoMessage = msg.message_type === "video" && !!msg.mediaUrl;
  const hasAudioMessage = isAudioChatMessage(msg);
  const hasImageHeader =
    msg.headerType === "media" &&
    !!msg.header?.media_url &&
    (msg.header?.media_type === "image" || msg.header?.media_type === "photo");
  const isVisualMediaCard = hasImageMessage || hasVideoMessage || hasImageHeader;
  const messageBubbleSizeSx = hasAudioMessage
    ? {
      width: CHAT_AUDIO_BUBBLE.width,
      minWidth: CHAT_AUDIO_BUBBLE.minWidth,
      flexShrink: CHAT_AUDIO_BUBBLE.flexShrink,
      maxWidth: { xs: "min(92vw, 340px)", sm: 340, md: 360 },
    }
    : isVisualMediaCard
      ? {
        width: CHAT_IMAGE_SIZE.cardWidth,
        maxWidth: CHAT_IMAGE_SIZE.cardWidth,
      }
      : {
        width: "auto",
        maxWidth: "70%",
      };
  const mediaContent = renderChatMediaContent(msg, openImageViewer);
    return (
      <Box key={msg.id} sx={{ }}>
      <Box key={msg.id} sx={{ mb: 2 }}>
          {/* React Button for each message */}
          {msg.type === 'date-divider' && (
            <>
              <Box sx={{ display: 'flex', justifyContent: 'center', my: 2 }}>
                <Box
                  sx={{
                    bgcolor: '#e0e0e0',
                    color: '#555',
                    px: 2,
                    py: 0.5,
                    borderRadius: '20px',
                    fontSize: '0.75rem',
                    fontWeight: 'bold',
                  }}
                >
                  {msg.content}
                </Box>
              </Box></>
          )}

          {msg.type === "system" && (
            <Box sx={{ textAlign: "center", mb: 1 }}>
              <Typography
                variant="caption"
                color="text.secondary"
                sx={{ display: "inline-block", fontWeight: 500 }}
              >
                {msg.content}
              </Typography>
              <Typography
                variant="caption"
                color="text.disabled"
                sx={{ display: "inline-block", ml: 0.75, fontSize: 11 }}
              >
                {msg.timestamp ? getProperTime(msg.timestamp) : ""}
              </Typography>
            </Box>
          )}
          {msg.type === "user" && (
            <><Box
              id={`msg-${msg.id}`}
              sx={{
                display: "flex",
                justifyContent: "flex-end",
                alignItems: "center",
                mb: 1.5,
                px: 1,
                minWidth: 0,
              }}
            >
                <ReactionButton
      onClick={() => {
        setReactingWamid(msg.wamid);
        setEmojiDialogOpen(true);
      }}
    /> 
              <Paper
                sx={{
                  position: "relative",
                  bgcolor: WA_THEME.sentBubble,
                  p: 1.5,
                  ...messageBubbleSizeSx,
                  borderRadius: "15px 15px 4px 15px",
                  boxShadow: "0 1px 2px rgba(0,0,0,0.08)",
                }}
              >
                {reactionCount > 0 && (
  <ReactionChip reactions={reactions} align="right" />
)}
                {/* ===== Bubble Tail (Right) ===== */}
                <Box
                  sx={{
                    position: "absolute",
                    right: -6,
                    bottom: 14,
                    width: 0,
                    height: 0,
                    borderTop: "6px solid transparent",
                    borderBottom: "6px solid transparent",
                    borderLeft: "6px solid #d9fdd3",
                  }} />
                {(msg.type === "user") && repliedMsg && (
                  <Box
                    sx={{
                      bgcolor: "#f4f7ff",
                      border: "1px solid #b6ccff",
                      px: 1.5,
                      py: 0.75,
                      mb: 1,
                      borderRadius: "10px",
                      cursor: "pointer",
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "flex-start",
                    }}
                    onClick={() => {
                      const el = document.getElementById(`msg-${repliedMsg.id}`);
                      if (el)
                        el.scrollIntoView({ behavior: "smooth", block: "center" });
                    } }
                  >
                    <Typography
                      variant="caption"
                      sx={{
                        fontWeight: 600,
                        color: "#4f7cff",
                        mb: 0.25,
                      }}
                    >
                      {repliedMsg.type === "user" ? "You" : contactname}
                    </Typography>

                    {repliedMsg.message_type === "image" &&
                      repliedMsg.mediaUrl ? (
                      <Box
                        component="img"
                        src={repliedMsg.mediaUrl}
                        alt="image preview"
                        sx={{ maxWidth: 60, maxHeight: 60, borderRadius: 1 }} />
                    ) : (
                      <Typography
                        variant="caption"
                        sx={{
                          color: "#444",
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          maxWidth: 240,
                        }}
                      >
                        {typeof repliedMsg.content === "object"
                          ? "[Order / Template]"
                          : repliedMsg.content?.slice(0, 50) || "[No content]"}
                      </Typography>
                    )}
                  </Box>
                )}

                {/* ===== MESSAGE CONTENT (LOGIC UNCHANGED) ===== */}
                {msg.message_type === "call" && typeof msg.content === "object" ? (
                  <CallMessageBubble callMeta={msg.content} />
                ) : msg.message_type === "order" && typeof msg.content === "object" ? (
                  <Box>
                    <Typography variant="body2" sx={{ fontWeight: 700 }}>
                      Catalog ID: {msg.content.catalogId}
                    </Typography>
                    <Typography variant="body2">
                      {msg.content.itemsCount} item
                      {msg.content.itemsCount > 1 ? "s" : ""}
                    </Typography>
                    <Typography variant="body2">
                      {msg.content.currency} {msg.content.totalPrice}
                    </Typography>
                  </Box>
                ) : mediaContent ? (
                  mediaContent
                ) : (
                  <>
                    {msg.headerType === "text" && msg.header && (
                      <Typography variant="body2" sx={{ fontWeight: 700, mb: 0.5 }}>
                        {msg.header}
                      </Typography>
                    )}

                    {msg.headerType === "media" && msg.header && (
                      <Box sx={{ mb: 1 }}>
                        {(msg.header.media_type === "image" ||
                          msg.header.media_type === "photo") &&
                          msg.header.media_url && (
                            <Box
                              component="img"
                              src={msg.header.media_url}
                              alt="header"
                              sx={CHAT_IMAGE_SX}
                              onClick={() => openImageViewer(msg.header.media_url)}
                            />
                          )}
                      </Box>
                    )}

                    <Typography
                      variant="body2"
                      sx={{ whiteSpace: "pre-wrap", wordBreak: "break-word" }}
                    >
                      <LinkifiedText text={msg.content} />
                    </Typography>

                    {msg.footer && (
                      <Typography
                        variant="caption"
                        sx={{ color: "#777", display: "block", mt: 0.5 }}
                      >
                        {msg.footer}
                      </Typography>
                    )}
                  </>
                )}

                {/* ===== TIME + DOUBLE TICK ===== */}
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "flex-end",
                    alignItems: "center",
                    gap: 0.5,
                    mt: 0.5,
                  }}
                >
                  <Typography
                    variant="caption"
                    sx={{ fontSize: 11, color: "#6b7280" }}
                  >
                    {getProperTime(msg.timestamp)}
                  </Typography>

                  {renderOutboundStatus(msg.status, msg.error_message)}
                </Box>

                {/* ===== Buttons & List (UNCHANGED) ===== */}
                {msg.buttons && (
                  <Box sx={{ display: "flex", flexDirection: "column", gap: 1, mt: 1 }}>
                    {msg.buttons.map((button, btnIndex) => (
                      <Button
                        key={btnIndex}
                        onClick={button.btn_value}
                        size="small"
                        variant="outlined"
                        fullWidth
                        sx={{
                          borderRadius: 20,
                          textTransform: "none",
                        }}
                      >
                        {button.btn_label}
                      </Button>
                    ))}
                  </Box>
                )}

                {msg.listName && (
                  <Typography variant="body2" sx={{ mt: 1, fontWeight: 500 }}>
                    {msg.listName}
                  </Typography>
                )}
              </Paper>
            </Box>
            </>
          )}

          {msg.type === "receive" && (
            <Box
              id={`msg-${msg.id}`}
              sx={{
                display: "flex",
                justifyContent: "flex-start",
                mb: 1.5,
                px: 1,
              }}
            >
              <Paper
                sx={{
                  position: "relative",
                  bgcolor: WA_THEME.receiveBubble,
                  p: 1.5,
                  ...messageBubbleSizeSx,
                  borderRadius: "15px 15px 15px 4px",
                  boxShadow: "0 1px 2px rgba(0,0,0,0.08)",
                }}
              >
                {reactionCount > 0 && (
  <ReactionChip reactions={reactions} align="left" />
)}
                {/* ===== Reply Preview (UNCHANGED LOGIC – DESIGN SOFTENED) ===== */}
                {repliedMsg && (
                  <Box
                    sx={{
                      bgcolor: "#f5f5f5",
                      borderLeft: "3px solid #c7d2fe",
                      px: 1.25,
                      py: 0.5,
                      mb: 1,
                      borderRadius: 1,
                      cursor: "pointer",
                    }}
                    onClick={() => {
                      const el = document.getElementById(`msg-${repliedMsg.id}`);
                      if (el)
                        el.scrollIntoView({ behavior: "smooth", block: "center" });
                    } }
                  >
                    <Typography
                      variant="caption"
                      sx={{
                        fontWeight: 600,
                        color: "#4f7cff",
                        display: "block",
                        mb: 0.25,
                      }}
                    >
                      {repliedMsg.type === "user" ? "You" : contactname}
                    </Typography>

                    {repliedMsg.message_type === "image" &&
                      repliedMsg.mediaUrl ? (
                      <Box
                        component="img"
                        src={repliedMsg.mediaUrl}
                        alt="preview"
                        sx={{ maxWidth: 60, maxHeight: 60, borderRadius: 1 }} />
                    ) : (
                      <Typography
                        variant="caption"
                        sx={{
                          color: "#555",
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          maxWidth: 220,
                        }}
                      >
                        {typeof repliedMsg.content === "object"
                          ? "[Order / Template]"
                          : repliedMsg.content?.slice(0, 50) || "[No content]"}
                      </Typography>
                    )}
                  </Box>
                )}

                {/* ===== MESSAGE CONTENT (LOGIC UNCHANGED) ===== */}
                {msg.message_type === "call" && typeof msg.content === "object" ? (
                  <CallMessageBubble callMeta={msg.content} />
                ) : msg.message_type === "order" && typeof msg.content === "object" ? (
                  <Box>
                    <Typography variant="body2" sx={{ fontWeight: 700 }}>
                      Catalog ID: {msg.content.catalogId}
                    </Typography>
                    <Typography variant="body2">
                      {msg.content.itemsCount} item
                      {msg.content.itemsCount > 1 ? "s" : ""}
                    </Typography>
                    <Typography variant="body2">
                      {msg.content.currency} {msg.content.totalPrice}
                    </Typography>
                  </Box>
                ) : mediaContent ? (
                  mediaContent
                ) : (
                  <>
                    {msg.headerType === "text" && msg.header && (
                      <Typography variant="body2" sx={{ fontWeight: 700, mb: 0.5 }}>
                        {msg.header}
                      </Typography>
                    )}

                    {msg.headerType === "media" && msg.header && (
                      <Box sx={{ mb: 1 }}>
                        {(msg.header.media_type === "image" ||
                          msg.header.media_type === "photo") &&
                          msg.header.media_url && (
                            <Box
                              component="img"
                              src={msg.header.media_url}
                              alt="header"
                              sx={CHAT_IMAGE_SX}
                              onClick={() => openImageViewer(msg.header.media_url)}
                            />
                          )}
                      </Box>
                    )}

                    <Typography
                      variant="body2"
                      sx={{ whiteSpace: "pre-wrap", wordBreak: "break-word" }}
                    >
                      <LinkifiedText text={msg.content} />
                    </Typography>

                    {msg.footer && (
                      <Typography
                        variant="caption"
                        sx={{ color: "#777", display: "block", mt: 0.5 }}
                      >
                        {msg.footer}
                      </Typography>
                    )}
                  </>
                )}

                {/* ===== TIME (RIGHT INSIDE BUBBLE) ===== */}
                <Typography
                  variant="caption"
                  sx={{
                    display: "block",
                    textAlign: "right",
                    fontSize: 11,
                    color: "#9ca3af",
                    mt: 0.5,
                  }}
                >
                  {getProperTime(msg.timestamp)}
                </Typography>
              </Paper>
            <ReactionButton
      onClick={() => {
        setReactingWamid(msg.wamid);
        setEmojiDialogOpen(true);
      }}
    />
    
            </Box>
          )}

        </Box></Box>
  )})}
</Box>
 <div style={{ display: "flex", justifyContent: "flex-end"}}>
            {showScrollToBottom && (
           <Fab
             color="primary"
             size="small"
             onClick={handleScrollToBottom}
             aria-label="scroll to bottom"
             sx={{
              display: "flex",
               position: "absolute",
               bottom: 106,
               zIndex: 20,
               boxShadow: 3,
               opacity: '50%',
             }}
           >
             <ArrowDownwardIcon />
           </Fab>
         )}
</div>

        {/* Message Input */}
<Box
  sx={{
    px: { xs: 1.5, md: 2 },
    py: 1,
    borderTop: "1px solid #d8e0e5",
    bgcolor: "#fff",
    position: { xs: "fixed", md: "sticky" },
    bottom: 0,
    left: 0,
    width: "100%",
    zIndex: 30,
    boxShadow: "0 -4px 8px -6px rgba(0,0,0,0.15)",
  }}
>
  <Box
    sx={{
      display: "flex",
      alignItems: "center",
      gap: 1,
      bgcolor: "#f8fafc",
      borderRadius: "28px",
      px: 1.2,
      py: 0.5,
      border: "1px solid #e2e8f0",
    }}
  >
    {/* Text Input */}
    {!recordedAudio &&
    <><TextField
                    fullWidth
                    placeholder={timer && !isRecording
                      ? "Type message here"
                      : isRecording ? "Speak now..." :"Conversation window expired. Use templates"}
                    value={message}
                    disabled={!timer || !canReplyToSelectedChat}
                    onChange={(e) => setMessage(e.target.value)}
                    multiline
                    minRows={1}
                    maxRows={1}
                    onKeyPress={(e) => {
                      if (e.key === "Enter" && e.ctrlKey) {
                        e.preventDefault();
                        handleSendMessage();
                      }
                    } }
                    variant="standard"
                    InputProps={{
                      disableUnderline: true,
                      sx: {
                        fontSize: 14,
                        px: 1,
                      },
                      endAdornment: (
                        <InputAdornment position="end">
                          {/* Emoji */}
                          <IconButton
                            size="small"
                            disabled={!timer || !canReplyToSelectedChat}
                            onClick={() => setEmojiDialogOpen(true)}
                            sx={{ color: "#667781", border: "1px solid #e2e8f0", bgcolor: "#fff", mr: 0.4 }}
                          >
                            <InsertEmoticonIcon fontSize="small" />
                          </IconButton>
                          {/* Image */}
                          <IconButton
                            size="small"
                            disabled={!timer || !canReplyToSelectedChat}
                            onClick={handleImageIconClick}
                            sx={{ color: "#667781", border: "1px solid #e2e8f0", bgcolor: "#fff", mr: 0.4 }}
                          >
                            <ImageIcon fontSize="small" />
                          </IconButton>

                          {/* Audio */}
                          <IconButton
                            size="small"
                            disabled={!timer || !canReplyToSelectedChat}
                            onClick={handleAudioIconClick}
                            sx={{ color: "#667781", border: "1px solid #e2e8f0", bgcolor: "#fff", mr: 0.4 }}
                          >
                            <AudioFile fontSize="small" />
                          </IconButton>
                          <IconButton size="small" sx={{ mr: 0.5, border: "1px solid #e2e8f0", bgcolor: "#fff" }} disabled={!timer || isRecording || !canReplyToSelectedChat} onClick={handleStartRecording}>
                            <span role="img" aria-label="mic">🎤</span>
                          </IconButton>
                          {isRecording && (
                            <IconButton size="small" color="error" onClick={handleStopRecording}>
                              <span role="img" aria-label="stop"><StopCircle /></span>
                            </IconButton>
                          )}
                        </InputAdornment>
                      ),
                    }} /><>
                      {/* Send Button */}
                      {timer ? (
                        <Button
                          variant="contained"
                          onClick={handleSendMessage}
                          disabled={!canReplyToSelectedChat}
                          sx={{
                            borderRadius: "999px",
                            px: 2.7,
                            py: 0.8,
                            textTransform: "none",
                            fontWeight: 600,
                            minWidth: "auto",
                            boxShadow: "none",
                            bgcolor: WA_THEME.primary,
                            "&:hover": { bgcolor: WA_THEME.primaryDark, boxShadow: "none" },
                          }}
                        >
                          Send
                        </Button>
                      ) : (
                        <Button
                          variant="contained"
                          onClick={() => setTemplateDialogOpen(true)}
                          sx={{
                            borderRadius: "999px",
                            px: 2.7,
                            py: 0.8,
                            textTransform: "none",
                            fontWeight: 600,
                            minWidth: "auto",
                            boxShadow: "none",
                            bgcolor: WA_THEME.primary,
                            "&:hover": { bgcolor: WA_THEME.primaryDark, boxShadow: "none" },
                          }}
                        >
                          Templates
                        </Button>
                      )}
                    </></>
    }
    {recordedAudio && (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, justifyContent:'flex-end' }}>
      <audio controls src={URL.createObjectURL(recordedAudio)} style={{ width: 190 }} />
      <Button
        variant="contained"
        color="primary"
        onClick={handleSendRecordedAudio}
        disabled={audioUploading || !canReplyToSelectedChat}
        sx={{ minWidth: "auto", px: 2, py: 1, borderRadius: "20px", textTransform: "none", fontWeight: "bold" }}
      >
        {audioUploading ? <CircularProgress size={20} /> : 'Send Voice'}
      </Button>
      <Button onClick={() => {
        setRecordedAudio(null);
        stopMicrophone();
        }} disabled={audioUploading}>Cancel</Button>
    </Box>
  )}
  </Box>
</Box>

        </>
        )}
      </ChatColumn>
      <ContactColumn
        mobileOpen={showContactMobile}
        onMobileClose={() => setShowContactMobile(false)}
      >
    {/* Contact Information Content - Scrollable */}
<Box
  sx={{
    flex: 1,
    minWidth: 0,
    overflowY: "auto",
    overflowX: "hidden",
    bgcolor: "#f8fafc",
    px: 1.5,
    pb: 2,
  }}
>
  {/* ================= BASIC INFORMATION ================= */}
  {/* Contact Header */}
<Box sx={{
  p: 1.25,
  mx: -1.5,
  px: 1.5,
  bgcolor: "#fff",
  borderBottom: "1px solid #eef2f7",
}}>
  <Box
    sx={{
      display: "flex",
      alignItems: "center",
      gap: 1,
      minWidth: 0,
    }}
  >
    {/* Left Section */}
    <Box sx={{ display: "flex", alignItems: "center", flex: 1, minWidth: 0 }}>
      {/* Avatar */}
      <Avatar
        sx={{
          bgcolor: WA_THEME.primary,
          width: 44,
          height: 44,
          mr: 1.5,
          fontSize: 20,
          flexShrink: 0,
        }}
      >
        {members?.name
          ?.[0]
          ?.split(" ")
          ?.map((n) => n[0])
          ?.join("")
          ?.toUpperCase()}
      </Avatar>

      {/* Name & Status */}
      <Box sx={{ minWidth: 0, flex: 1 }}>
        <Typography
          variant="body1"
          sx={{
            fontWeight: 600,
            lineHeight: 1.2,
            fontFamily: `"Poppins", sans-serif`,
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
          }}
        >
          {members?.name || "Customer name"}
        </Typography>

        {/* <Box sx={{ display: "flex", alignItems: "center", mt: 0.3 }}>
          <Box
            sx={{
              width: 8,
              height: 8,
              bgcolor: "#22c55e",
              borderRadius: "50%",
              mr: 0.7,
            }}
          />
          <Typography
            variant="caption"
            sx={{ color: "#22c55e", fontWeight: 500, fontFamily: `"Poppins", sans-serif` }}
          >
            Available
          </Typography>
        </Box> */}
      </Box>
    </Box>

    {/* Right Section */}
    <Box sx={{ display: "flex", alignItems: "center", flexShrink: 0 }}>
        <IconButton
         component="a"
         href={`https://wa.me/${members?.phone_number}`}
         target="_blank"
         rel="noopener noreferrer"
         size="small"
         sx={{
          bgcolor: "#e8f5e9",
          color: "#25D366",
          "&:hover": { bgcolor: "#dff3e3" },
          }}
       >
  <WhatsAppIcon fontSize="small" />
</IconButton>

{/* 
      <IconButton
        size="small"
        sx={{
          bgcolor: "#f1f5f9",
          color: "#555",
          "&:hover": { bgcolor: "#e5e7eb" },
        }}
      >
        <ChatIcon fontSize="small" />
      </IconButton> */}
    </Box>
  </Box>
</Box>

  <Box sx={{ pt: 1 }}>
    <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
      <Typography
        variant="caption"
        sx={{ color: "#64748b", fontWeight: 700, letterSpacing: 0.6 }}
      >
        CONTACT INFO
      </Typography>
      <IconButton
        size="small"
        onClick={() => setSectionOpen((p) => ({ ...p, contactInfo: !p.contactInfo }))}
      >
        {sectionOpen.contactInfo ? <ExpandLess fontSize="small" /> : <ExpandMore fontSize="small" />}
      </IconButton>
    </Box>
  </Box>
  {sectionOpen.contactInfo && (
  <Box sx={CONTACT_PANEL_CARD_SX}>
    <Typography sx={{ fontFamily: `"Poppins", sans-serif`, fontWeight: 600, mb: 1.5 }}>
      Basic Information
    </Typography>

    <Box sx={{ display: "flex", alignItems: "center", flexWrap: "wrap", gap: 0.5, mb: 1, minWidth: 0 }}>
      <Typography variant="body2" sx={{ fontFamily: `"Poppins", sans-serif`, color: "#666" }}>
        Phone Number :
      </Typography>

      <Typography
        variant="body2"
        sx={{ fontFamily: `"Poppins", sans-serif`, fontWeight: 500, wordBreak: "break-all" }}
      >
        {members?.phone_number}
      </Typography>

      <Box
        component="img"
        src="https://flagcdn.com/w20/in.png"
        alt="flag"
        sx={{ width: 20, height: 14, flexShrink: 0 }}
      />
    </Box>

    <Typography
      variant="body2"
      sx={{ color: "#666", fontFamily: `"Poppins", sans-serif`, wordBreak: "break-word" }}
    >
      E-mail : {members?.email || "—"}
    </Typography>
  </Box>
  )}
  <Box sx={{ pt: 1 }}>
    <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
      <Typography
        variant="caption"
        sx={{ color: "#64748b", fontWeight: 700, letterSpacing: 0.6 }}
      >
        CONTACT ATTRIBUTES
      </Typography>
      <IconButton
        size="small"
        onClick={() => setSectionOpen((p) => ({ ...p, contactAttrs: !p.contactAttrs }))}
      >
        {sectionOpen.contactAttrs ? <ExpandLess fontSize="small" /> : <ExpandMore fontSize="small" />}
      </IconButton>
    </Box>
  </Box>
  {sectionOpen.contactAttrs && (
  <Box sx={{ ...CONTACT_PANEL_CARD_SX, mb: 2 }}>
    <Box sx={{ mb: 1.25, minWidth: 0 }}>
      <Typography variant="caption" sx={{ color: "#6b7280", display: "block", mb: 0.25 }}>
        whatsapp_{members?.phone_number?.slice(-6) || "n/a"}
      </Typography>
      <Typography variant="body2" sx={{ fontWeight: 600, wordBreak: "break-all" }}>
        {members?.phone_number || "-"}
      </Typography>
    </Box>
    <Box sx={{ minWidth: 0 }}>
      <Typography variant="caption" sx={{ color: "#6b7280", display: "block", mb: 0.25 }}>
        name
      </Typography>
      <Typography variant="body2" sx={{ fontWeight: 600, wordBreak: "break-word" }}>
        {members?.name || "-"}
      </Typography>
    </Box>
  </Box>
  )}
  {/* ================= CONTACT CUSTOM PARAMETERS ================= */}
  {/* <Box sx={{ p: 2, borderBottom: "1px solid #eaeaea" }}> */}
    {/* <Box
      sx={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        mb: 1.5,
      }}
    >
      <Typography sx={{ fontWeight: 600 ,  fontFamily: `"Poppins", sans-serif` }}>
        Contact custom parameters
      </Typography>

      <IconButton size="small">
        <EditIcon fontSize="small" />
      </IconButton>
    </Box> */}

    {/* Parameter Row */}
    {/* <Box
      sx={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        p: 1,
        mb: 1,
        borderRadius: 1,
        border: "1px solid #e5e7eb",
      }}
    >
      <Typography variant="body2" sx={{ color: "#555" , fontFamily: `"Poppins", sans-serif` }}>
        Name
      </Typography>

      <Box sx={{ display: "flex", alignItems: "center", gap: 1  }}>
        <Typography variant="body2">
          {members?.name}
        </Typography>
        <IconButton size="small">✕</IconButton>
      </Box>
    </Box> */}
  {/* </Box> */}

  {/* ================= TAGS ================= */}
  <Box sx={{ pt: 1 }}>
    <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
      <Typography
        variant="caption"
        sx={{ color: "#64748b", fontWeight: 700, letterSpacing: 0.6 }}
      >
        TAGS
      </Typography>
      <IconButton
        size="small"
        onClick={() => setSectionOpen((p) => ({ ...p, tags: !p.tags }))}
      >
        {sectionOpen.tags ? <ExpandLess fontSize="small" /> : <ExpandMore fontSize="small" />}
      </IconButton>
    </Box>
  </Box>
  {sectionOpen.tags && (
  <Box sx={CONTACT_PANEL_CARD_SX}>
    <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
      <LabelIcon sx={{ mr: 1, color: "#666" }} />
      <Typography sx={{ fontWeight: 600 ,  fontFamily: `"Poppins", sans-serif` }}>
        Tags
      </Typography>
    </Box>

    <Box sx={{ display: "flex", gap: 1, minWidth: 0, flexWrap: "wrap" }}>
                <Autocomplete
                  freeSolo
                  options={availableTags.filter(
                    (tag) => !members?.tags?.find((selected) => selected.id === tag.getId())
                  )?.map((tag) => tag.getName())}
                  getOptionLabel={(option) => (typeof option === "string" ? option : option.name)}
                  value={newTag}
                  onChange={(_, value) => {
                    if (typeof value === "string") {
                      setNewTag(value);
                    } else if (value && value.name) {
                      setNewTag(value.name);
                    } else {
                      setNewTag("");
                    }
                  }}
                  onInputChange={(_, value) => setNewTag(value)}
                  onKeyPress={handleKeyPress}
                  sx={{ flex: 1, minWidth: 0 }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      placeholder="Add a tag..."
                      size="small"
                      sx={{
                        width: "100%",
                        "& .MuiOutlinedInput-root": {
                          borderRadius: 2,
                        },
                      }}
                    />
                  )}
                />
                <Button
                  variant="outlined"
                  size="small"
                  onClick={handleAddTag}
                  disabled={!newTag.trim()}
                  sx={{ borderRadius: 2, minWidth: "auto", px: 2 }}
                >
                  <AddIcon fontSize="small" />
                </Button>
              </Box>
               {members?.tags?.length > 0 &&
      members.tags?.map((tag) => (
            <Chip
              key={tag.id}
              label={tag.name}
              onDelete={() => handleRemoveTag(tag.id)}
              size="small"
              sx={{
              backgroundColor: `${getTagColor(tag.color)}15`,
              color: getTagColor(tag.color),
              fontWeight: 500,
              fontSize: "0.75rem",
              fontFamily: "Poppins, sans-serif",
              marginTop: 1,
              marginRight: 1
              }}
            />
  ))}
  </Box>
  )}

{contactId && (
  <CallHistory
    serviceId={appConfig.getServiceId()}
    contactId={contactId}
    phoneNumber={members?.phone_number}
    refreshKey={callHistoryRefreshKey}
  />
)}
  {/* ================= NOTES ================= */}
  <Box sx={{ pt: 1 }}>
    <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
      <Typography
        variant="caption"
        sx={{ color: "#64748b", fontWeight: 700, letterSpacing: 0.6 }}
      >
        NOTES
      </Typography>
      <IconButton
        size="small"
        onClick={() => setSectionOpen((p) => ({ ...p, notes: !p.notes }))}
      >
        {sectionOpen.notes ? <ExpandLess fontSize="small" /> : <ExpandMore fontSize="small" />}
      </IconButton>
    </Box>
  </Box>
  {sectionOpen.notes && (
  <Box sx={CONTACT_PANEL_CARD_SX}>
    {members?.notes?.length > 0 ? members.notes.map((note) => (

        <Box
          key={note.id}
          sx={{
            mb: 2,
            p: 2,
            borderRadius: 1,
            border: "1px solid #e5e7eb",
            bgcolor: "#fafafa",
          }}
        >
          <Typography
            variant="caption"
            sx={{ color: "#999", display: "block", mb: 0.5, fontFamily: `"Poppins", sans-serif`}}
          >
            {note.author} • {note.date}
          </Typography>

          <Typography variant="body2" sx={{ fontFamily: `"Poppins", sans-serif`}}>
            {note.text}
          </Typography>
        </Box>
    )) : (
      <Typography variant="body2" color="text.secondary">No notes yet.</Typography>
    )}
  </Box>
  )}
</Box>
      </ContactColumn>


      <ContactsSelectDialog
      open={open}
      setOpen={setOpen}
      setSelectedNewContacts={handleSelectContact}
      contactError={contactError}
      />

      <Dialog
        open={assignDialogOpen}
        onClose={() => {
          if (!assignBusy) {
            setAssignDialogOpen(false);
            setAssignTargetId(null);
          }
        }}
        fullWidth
        maxWidth="sm"
      >
        <Box sx={{ p: 2 }}>
          <Typography variant="h6" sx={{ mb: 2, fontFamily: `"Poppins", sans-serif` }}>
            {selectedChat?.current_assignee_account_id ? "Reassign" : "Assign"} conversation
          </Typography>
          <Autocomplete
            options={[TEAM_INBOX_AI_ASSIGNEE_OPTION, ...(staffForAssign || [])]}
            getOptionLabel={(o) =>
              o
                ? `${o.first_name || ""} ${o.last_name || ""}`.trim() || o.email || o.id
                : ""
            }
            value={
              assignTargetId === TEAM_INBOX_AI_ASSIGNEE_OPTION.id
                ? TEAM_INBOX_AI_ASSIGNEE_OPTION
                : (staffForAssign || []).find((s) => s.id === assignTargetId) || null
            }
            onChange={(_e, v) => setAssignTargetId(v?.id || null)}
            renderInput={(params) => (
              <TextField {...params} label="Assign to team member or AI" size="small" />
            )}
          />
          <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 1, mt: 2 }}>
            <Button
              onClick={() => {
                setAssignDialogOpen(false);
                setAssignTargetId(null);
              }}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              disabled={!assignTargetId || assignBusy}
              onClick={handleConfirmAssign}
            >
              Save
            </Button>
          </Box>
        </Box>
      </Dialog>

      <Dialog
        open={unassignDialogOpen}
        onClose={() => !assignBusy && setUnassignDialogOpen(false)}
        fullWidth
        maxWidth="xs"
      >
        <Box sx={{ p: 2 }}>
          <Typography variant="h6" sx={{ mb: 1.5, fontFamily: `"Poppins", sans-serif` }}>
            Unassign conversation
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
            Do you want to unassign this chat?
          </Typography>
          <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 1 }}>
            <Button onClick={() => setUnassignDialogOpen(false)} disabled={assignBusy}>
              Cancel
            </Button>
            <Button variant="contained" color="error" onClick={handleConfirmUnassign} disabled={assignBusy}>
              Unassign
            </Button>
          </Box>
        </Box>
      </Dialog>

      <Dialog
        open={closeDialogOpen}
        onClose={() => !assignBusy && setCloseDialogOpen(false)}
        fullWidth
        maxWidth="xs"
      >
        <Box sx={{ p: 2 }}>
          <Typography variant="h6" sx={{ mb: 1.5, fontFamily: `"Poppins", sans-serif` }}>
            Close conversation
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
            Do you want to close this chat?
          </Typography>
          <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 1 }}>
            <Button onClick={() => setCloseDialogOpen(false)} disabled={assignBusy}>
              Cancel
            </Button>
            <Button variant="contained" color="error" onClick={handleConfirmClose} disabled={assignBusy}>
              Close
            </Button>
          </Box>
        </Box>
      </Dialog>
      <Snackbar
        open={snackbar.open}
        autoHideDuration={3500}
        onClose={() => setSnackbar((prev) => ({ ...prev, open: false }))}
      >
        <Alert
          onClose={() => setSnackbar((prev) => ({ ...prev, open: false }))}
          severity={snackbar.severity}
          sx={{ width: "100%" }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>

      {/* Template Dialog */}
      <Dialog
        open={templateDialogOpen}
        onClose={handleCloseTemplateDialog}
        maxWidth="md"
        fullWidth
      >
        <Box sx={{ p: 2 }}>
          <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 1 }}>
            <Typography variant="h6" sx={{ fontFamily: "Poppins, sans-serif" }}>Send Template</Typography>
            {/* <IconButton onClick={handleCloseTemplateDialog} size="small">
              <DeleteIcon /> 
            </IconButton> */}
          </Box>
          {renderSendTemplate()}
          <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 1, mt: 2 }}>
            <Button onClick={handleCloseTemplateDialog}>Cancel</Button>
            <Button
              variant="contained"
              onClick={() => {
                handleSave();
              }}
            >
              Send Template
            </Button>
          </Box>
        </Box>
      </Dialog>

      {/* Image Upload Dialog */}
      {/*<Dialog
        open={imageDialogOpen}
        onClose={() => { setImageDialogOpen(false); setSelectedImage(null); setCaption(""); }}
        maxWidth="xs"
        fullWidth
      >
        <Box sx={{ p: 3, display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2 }}>
          <Typography variant="h6">Upload Image</Typography>
          <input
            accept="image/*"
            type="file"
            style={{ display: 'none' }}
            id="image-upload-input"
            onChange={handleImageChange}
          />
          <label htmlFor="image-upload-input">
            <Button variant="outlined" component="span">
              Choose Image
            </Button>
          </label>
          {selectedImage && (
            <>
              <Box sx={{ mt: 2, mb: 2 }}>
                <img
                  src={URL.createObjectURL(selectedImage)}
                  alt="preview"
                  style={{ maxWidth: 200, maxHeight: 200, borderRadius: 8 }}
                />
              </Box>
              <TextField
                label="Add a caption"
                value={caption}
                onChange={e => setCaption(e.target.value)}
                fullWidth
                size="small"
                multiline
                maxRows={3}
                sx={{ mt: 1, mb: 1 }}
              />
            </>
          )}
          <Box sx={{ display: 'flex', gap: 1, mt: 2 }}>
            <Button onClick={() => { setImageDialogOpen(false); setSelectedImage(null); setCaption(""); }} disabled={imageUploading}>Cancel</Button>
            <Button
              variant="contained"
              onClick={handleSendImage}
              disabled={!selectedImage || imageUploading}
            >
              {imageUploading ? <CircularProgress size={20} /> : 'Send Image'}
            </Button>
          </Box>
        </Box>
      </Dialog>
      */}

      {/* Audio Upload Dialog */}
      {/*<Dialog
        open={audioDialogOpen}
        onClose={() => { setAudioDialogOpen(false); setSelectedAudio(null); }}
        maxWidth="xs"
        fullWidth
      >
        <Box sx={{ p: 3, display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2 }}>
          <Typography variant="h6">Upload Audio</Typography>
          <input
            accept=".aac,.amr,.mp3,.m4a"
            type="file"
            style={{ display: 'none' }}
            id="audio-upload-input"
            onChange={handleAudioChange}
          />
          <label htmlFor="audio-upload-input">
            <Button variant="outlined" component="span">
              Choose Audio
            </Button>
          </label>
          {selectedAudio && (
            <>
              <Box sx={{ mt: 2, mb: 2 }}>
                <audio controls src={URL.createObjectURL(selectedAudio)} style={{ width: 200 }} />
              </Box>
            </>
          )}
          <Box sx={{ display: 'flex', gap: 1, mt: 2 }}>
            <Button onClick={() => { setAudioDialogOpen(false); setSelectedAudio(null); }} disabled={audioUploading}>Cancel</Button>
            <Button
              variant="contained"
              onClick={handleSendAudio}
              disabled={!selectedAudio || audioUploading}
            >
              {audioUploading ? <CircularProgress size={20} /> : 'Send Audio'}
            </Button>
          </Box>
        </Box>
      </Dialog> */}


      {/*---- for Image upload -----*/}
      <MediaUploadDialog
        isOpen={imageDialogOpen}
        type="image"
        width={450}
        title="Upload Image"
        chooseLabel="Choose Image"
        confirmLabel="Send Image"
        onSubmit={handleSendImage}
        onCancel={() => setImageDialogOpen(false)}
        loading={imageUploading}
      />
  
      <MediaUploadDialog
        isOpen={audioDialogOpen}
        type="audio"
        width={450}
        title="Upload Audio"
        chooseLabel="Choose Audio"
        confirmLabel="Send Audio"
        onSubmit={handleSendAudio}
        onCancel={() => setAudioDialogOpen(false)}
        loading={audioUploading}
      />

      <MediaUploadDialog
        isOpen={emojiDialogOpen}
        type="emoji"
        title={emojiTitle}
        onSubmit={handleEmojiClick}
        onCancel={() => {
          setEmojiDialogOpen(false);
          setReactingWamid(null);
          }}
      />

      <ImageViewerOverlay
        open={imageViewer.open}
        imageUrl={imageViewer.url}
        caption={imageViewer.caption}
        onClose={closeImageViewer}
      />

      {incomingCall && phoneNumberId && (
        <IncomingCallNotification
          incomingCall={incomingCall}
          onClear={clearIncomingCall}
          serviceId={appConfig.getServiceId()}
          phoneNumberId={phoneNumberId}
        />
      )}

      {/* Emoji Dialog for message reaction or sending emoji */}
      {/* <Dialog
        open={emojiDialogOpen}
        onClose={() => { setEmojiDialogOpen(false); setReactingWamid(null); }}
        maxWidth="xs"
        fullWidth
      >
        <Box sx={{ p: 2, display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2 }}>
          <Typography variant="h6">{reactingWamid ? 'React to Message' : 'Select Emoji'}</Typography>
          <Picker
            onEmojiSelect={handleEmojiClick}
            data={data}
            title={reactingWamid ? 'React to Message' : 'Pick your emoji'}
            emoji="point_up"
            style={{ width: '100%' }}
            showPreview={false}
            showSkinTones={false}
          />
        </Box>
      </Dialog> */}

     


    </Box>
  );
};

export default TeamChatView;
